<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Clientes</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <b-button v-if="countFilter > 0" variant="primary" class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom title="Limpar filtros" @click="ResetFilter()">
              <i class="fas fa-eraser"></i>
            </b-button>
            <b-button variant="primary" class="input-group-text btn-sm ml-1 mt-3" v-b-tooltip.hover.bottom
              title="Procurar cliente" @click="OpenModalSearchMerchant()">
              <i class="fas fa-question"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button class="btn btn-outline-secondary dropdown-toggle-ellipsis" type="button"
                      v-b-tooltip.hover.right title="Mais opções" id="dropdownMenuButton" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)">
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                      <!-- <a class="dropdown-item" href="#" v-on:click.stop="OpenModalReportProfit($event, true)"
                        v-if="isMerchantRoot">
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de faturamento de clientes DIRETOS
                        </template>
                      </a>
                      <a class="dropdown-item" href="#" v-on:click.stop="OpenModalReportProfit($event, false)"
                        v-if="isMerchantRoot">
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de faturamento de clientes INDIRETOS
                        </template>
                      </a>
                      <a class="dropdown-item" href="#" v-on:click.stop="OpenModalReportState($event)"
                        v-if="isMerchantRoot">
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de faturamento de clientes por estado
                        </template>
                      </a>
                      <a class="dropdown-item" href="#" v-on:click.stop="OpenModalReportCity($event)"
                        v-if="isMerchantRoot">
                        <template>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório de faturamento de clientes por cidade
                        </template>
                      </a> -->
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loading"></loader>
              <table class="table mb-0" v-if="!loading">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">ID
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">Tipo de Conta</th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0 text-left">Localidade</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0" v-if="isRemoved">Bloqueado</th>
                    <th scope="col" class="border-0" v-if="isRemoved">Data de Remoção</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(merchant, index) in merchants" :key="index">
                    <td v-if="
                      merchant.AdditionalInformation.MktCampaign.utm_source != null &&
                      merchant.AdditionalInformation.MktCampaign.utm_source != ''
                    " v-b-tooltip.hover title="Cliente conquistado através de mídia paga">
                      <img style="height: 28px" src="https://image.flaticon.com/icons/svg/2301/2301162.svg" />
                    </td>
                    <td v-else></td>
                    <td v-if="merchant.IsCreditRestricted" v-b-tooltip.hover title="Restrição de crédito">
                      <i class="fas fa-exclamation-triangle fa-2x fa-red"></i>
                    </td>
                    <td v-else></td>
                    <td>
                      <div>{{ merchant.Id }}</div>
                    </td>
                    <td class="text-left td-with-subs">
                      <div>{{ merchant.Name | substring(50) }}</div>
                      <span>{{ merchant.Identity | identity }}</span>
                    </td>
                    <td>
                      <div>{{ merchant.MerchantType.Name }}</div>
                    </td>
                    <td>
                      <div>{{ merchant.SourceDescription }}</div>
                      <span class="td-span-style" v-if="
                        merchant.Partner.PartnerType.Name != null &&
                        merchant.Partner.PartnerType.Name != undefined &&
                        merchant.Partner.PartnerType.Name != ''
                      ">{{ merchant.Partner.PartnerType.Name | upper }}</span>
                    </td>
                    <td v-if="merchant.Address.CityName != undefined && merchant.Address.CityName != ''"
                      class="text-left">
                      {{ merchant.Address.CityName }} /
                      {{ merchant.Address.StateInitials }}
                    </td>
                    <td v-else></td>
                    <td class="td-with-subs">
                      <div>{{ merchant.CreatedDate | date }}</div>
                      <span>{{ merchant.CreatedDate | date("HH:mm:ss") }}</span>
                    </td>
                    <td v-if="isRemoved">
                      <i :class="[GetBlockedClass(merchant.IsBlocked)]"></i>
                    </td>
                    <td v-if="isRemoved">
                      <div
                        v-if="merchant.MerchantHistory !== null && merchant.MerchantHistory[0] !== null && merchant.MerchantHistory[0].ChangedDate != null">
                        <span>{{ merchant.MerchantHistory[0].ChangedDate | date("DD/MM/yyyy HH:mm:ss") }}</span>
                      </div>
                      <div v-else>
                        <span>-</span>
                      </div>
                    </td>
                    <td>
                      <div class="dropdown">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          :title="IsAuthorizedShow() ? 'Opções' : 'Você não possui permissão'"
                          :disabled="!IsAuthorizedShow()">
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a v-if="$isAuthorize('Merchant', 'Get')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchant($event, index, true)">
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a v-if="
                            !merchant.IsRemoved && $isAuthorize('Merchant', 'Get') && $isAuthorize('Merchant', 'Update')
                          " class="dropdown-item" href="#" v-on:click="OpenMerchant($event, index)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a v-if="!merchant.IsBlocked && $isAuthorize('Merchant', 'UpdateBlocked')"
                            class="dropdown-item" href="#" v-on:click="OpenModalBlockMerchant(index, true)">
                            <i class="fas fa-ban mr-2"></i> Bloquear
                          </a>
                          <a v-if="merchant.IsBlocked && $isAuthorize('Merchant', 'UpdateBlocked')"
                            class="dropdown-item" href="#" v-on:click="OpenModalBlockMerchant(index, false)">
                            <i class="fas fa-ban mr-2"></i> Desbloquear
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'UpdateRemoved')"
                            class="dropdown-item" href="#" v-on:click="OpenModalRemoveMerchant(index, true)">
                            <i class="fas fa-minus-square mr-2"></i> Remover
                          </a>
                          <a v-if="merchant.IsRemoved && !merchant.IsBlocked && $isAuthorize('Merchant', 'UpdateRemoved')"
                            class="dropdown-item" href="#" v-on:click="OpenModalRemoveMerchant(index, false)">
                            <i class="fas fa-check-square mr-2"></i> Ativar
                          </a>
                          <a v-if="merchant.IsMerchantRoot" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantSubAccount($event, merchant.Id)">
                            <i class="fas fa-store-alt mr-1"></i> Visualizar subcontas
                          </a>
                          <!-- <a v-if="merchant.IdMerchantRoot != 0" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantSubAccountMarketPlace($event, merchant.Id, merchant.IdMerchantRoot)">
                            <i class="fas fa-store-alt mr-1"></i> Métodos de pagamento
                          </a> -->
                          <a v-if="$isAuthorize('Merchant', 'ListMerchantHistory')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantHistory($event, merchant.Id)">
                            <i class="fas fa-history mr-2"></i> Visualizar histórico
                          </a>
                          <a v-if="$isAuthorize('Transaction', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantTransaction($event, merchant.Id)">
                            <i class="fas fa-exchange-alt mr-2"></i> Visualizar transações
                          </a>
                          <a v-if="$isAuthorize('MerchantNotification', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantNotification($event, merchant.Id)">
                            <i class="fas fa-bell mr-2"></i> Notificações
                          </a>
                          <!-- <a v-if="$isAuthorize('Subscription', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantSubscription($event, merchant.Id)">
                            <i class="fas fa-file-signature"></i> Assinaturas
                          </a> -->
                          <!-- <a v-if="!merchant.IsRemoved && $isAuthorize('Ticket', 'Add')" class="dropdown-item" href="#"
                            v-on:click="
                              OpenTicketRegister($event, {
                                IdMerchant: merchant.Id,
                              })
                            ">
                            <i class="fas fa-ticket-alt mr-2"></i> Abrir chamado
                          </a> -->
                          <!-- <a v-if="!merchant.IsRemoved && $isAuthorize('Plan', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenPlan($event, merchant.Id)">
                            <i class="fas fa-sticky-note mr-2"></i> Plano
                          </a> -->
                          <!-- <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'ListNegotiation')"
                            class="dropdown-item" href="#" v-on:click="OpenMerchantNegotiation($event, merchant.Id)">
                            <i class="fas fa-hands-helping"></i> Negociações
                          </a> -->

                          <a v-if="!merchant.IsRemoved && $isAuthorize('MerchantSolicitation', 'Add') && merchant.IdMerchantRoot == 0"
                            class="dropdown-item" href="#" v-on:click="OpenUpdatePartner($event, merchant.Id)">
                            <i class="fas fa-handshake mr-2"></i> Alterar parceiro
                          </a>
                          <!-- <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'UpdateEmail')" class="dropdown-item"
                            href="#" v-on:click="OpenChangeEmail($event, merchant.Id)">
                            <i class="fas fa-envelope mr-2"></i> Alterar e-mail
                          </a> -->
                          <a v-if="
                            !merchant.IsRemoved &&
                            merchant.CodeSolicitationV2 == '' &&
                            (merchant.MerchantType.Code == '2' || merchant.MerchantType.Code == '3') &&
                            $isAuthorize('Merchant', 'GetContract')
                          " class="dropdown-item" href="#"
                            v-on:click="OpenMerchantContract($event, merchant, merchant.MerchantType.Code == '3')">
                            <i class="fas fa-file-signature mr-2"></i>
                            Contrato
                          </a>
                          <a v-if="
                            !merchant.IsRemoved &&
                            (merchant.MerchantType.Code == '2' || merchant.MerchantType.Code == '3') &&
                            $isAuthorize('MerchantDoc', 'List')
                          " class="dropdown-item" href="#" v-on:click="OpenMerchantDocument($event, merchant.Id)">
                            <i class="fas fa-file-alt mr-2"></i>
                            Documentos
                          </a>
                          <a v-if="$isAuthorize('MerchantNote', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenMerchantNotes($event, merchant.Id)">
                            <i class="fas fa-sticky-note mr-2"></i>
                            Atendimento ao cliente
                          </a>
                          <a v-if="!merchant.IsRsemoved && $isAuthorize('MerchantUser', 'List')" class="dropdown-item"
                            href="#" v-on:click="OpenMerchantContact($event, merchant.Id)">
                            <i class="fas fa-address-book mr-2"></i>
                            Contatos
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('MerchantUser', 'List')" class="dropdown-item"
                            href="#" v-on:click="OpenMerchantUser($event, merchant.Id)">
                            <i class="fas fa-user mr-2"></i>
                            Usuários do Cliente
                          </a>
                          <!-- <a v-if="!merchant.IsRemoved && $isAuthorize('Training', 'List')" class="dropdown-item"
                            href="#" v-on:click="OpenMerchantTrainings($event, merchant.Id)">
                            <i class="fas fa-headset mr-2"></i>
                            Reuniões
                          </a> -->
                          <a v-if="$isAuthorize('Fingerprint', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenModalFingerprintIP($event, merchant.Id)">
                            <i class="fas fa-fingerprint mr-1"></i> Empresas vinculadas
                          </a>
                          <a v-if="$isAuthorize('CheckingAccount', 'List')" class="dropdown-item" href="#"
                            v-on:click="OpenCheckingAccount($event, merchant.Id)">
                            <i class="fas fa-file-invoice mr-2"></i>
                            Conta Corrente
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('MerchantLimits', 'Update')"
                            class="dropdown-item" href="#" v-on:click="OpenModalMerchantLimits($event, merchant.Id)">
                            <i class="fas fa-wrench mr-2"></i>
                            Alterar limite
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'Clear')" class="dropdown-item"
                            href="#" v-on:click="ClearSession($event, merchant.Id)">
                            <i class="fas fa-eraser mr-2"></i>
                            Limpar sessão
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'Update')" class="dropdown-item"
                            href="#" v-on:click="LiberarDadosIntegracao($event, merchant.Id)">
                            <i class="fa-solid fa-lock-open mr-2"></i>
                            Liberar Dados de Integração
                          </a>
                          <a v-if="!merchant.IsRemoved && $isAuthorize('Merchant', 'Update')" class="dropdown-item"
                            href="#" v-on:click="OpenModalFrequenciaRepasse($event, merchant.Id)">
                            <i class="fa-solid fa-rotate mr-2"></i>
                            Alterar Frequência de Repasse
                          </a>
                          <a class="dropdown-item" href="#"
                            v-on:click="OpenModalClassificacao($event, merchant.Id)">
                            <i class="fa-solid fa-tags mr-2"></i>
                            Classificação
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="merchants == undefined || merchants == null || merchants.length == 0">
                    <td :colspan="[isRemoved ? '7' : '6']">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination class="float-right" v-model="pagination.PageNumber" :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage" aria-controls="my-table"></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="md" id="mFormBloquearMerchant"
      :title="!merchantBloquear.IsBlocked ? 'Bloquear merchant' : 'Desbloquear merchant'" :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingUpdateBlocked">
        <loader :is-loading="loadingUpdateBlocked"></loader>
      </div>
      <div v-else>
        <!-- Modelo -->
        <ValidationObserver tag="form" ref="BloquearMerchantForm">
          <p>Você tem certeza que deseja {{ !merchantBloquear.IsBlocked ? 'bloquear e remover' : 'desbloquear' }} o
            merchant
            <b> {{ merchantBloquear.Name }} ({{ merchantBloquear.Identity }})</b>
          </p>

          <d-form-row>
            <d-col md="7" class="form-group">
              <label>Usuário</label>
              <d-form-input type="text" v-model="$getUserInternal().Name" readonly />
            </d-col>

            <d-col md="5" class="form-group">
              <label>Data</label>
              <d-form-input type="text" v-bind:value="new Date() | date('DD/MM/YYYY - HH:mm')" readonly />
            </d-col>

            <d-col md="12">
              <label>Motivo do {{ !merchantBloquear.IsBlocked ? 'Bloqueio' : 'Desbloqueio' }}</label>
              <ValidationProvider rules="required|min:15" v-slot="{ errors, invalid }">
                <b-form-textarea type="text" rows="4" v-model="merchantBloquear.Observacao"
                  :class="validatedBloquearForm | showValidateError(invalid)" />
                <div class="invalid-feedback d-block" v-if="validatedBloquearForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

          </d-form-row>

        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" :variant="!merchantBloquear.IsBlocked ? 'danger' : 'success'"
          @click="UpdateBlockedMerchant(!merchantBloquear.IsBlocked)" :disabled="loadingUpdateBlocked">
          <template v-if="!loadingUpdateBlocked">
            {{ !merchantBloquear.IsBlocked ? 'Bloquear' : 'Desbloquear' }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingUpdateBlocked"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="md" id="mFormRemoverMerchant"
      :title="!merchantRemover.IsRemoved ? 'Remover merchant' : 'Ativar merchant'" :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingUpdateRemove">
        <loader :is-loading="loadingUpdateRemove"></loader>
      </div>
      <div v-else>
        <!-- Modelo -->
        <ValidationObserver tag="form" ref="RemoverMerchantForm">
          <d-form-row>
            <p>Você tem certeza que deseja {{ !merchantRemover.IsRemoved ? 'remover' : 'ativar' }} o merchant <b>
                {{ merchantRemover.Name }} ({{ merchantRemover.Identity }})</b></p>
            <d-col md="7" class="form-group">
              <label>Usuário</label>
              <d-form-input type="text" v-model="$getUserInternal().Name" readonly />
            </d-col>

            <d-col md="5" class="form-group">
              <label>Data</label>
              <d-form-input type="text" v-bind:value="new Date() | date('DD/MM/YYYY - HH:mm')" readonly />
            </d-col>
            <d-col md="12">
              <label>Motivo da {{ !merchantRemover.IsRemoved ? 'Remoção' : 'Ativação' }}</label>
              <ValidationProvider rules="required|min:15" v-slot="{ errors, invalid }">
                <b-form-textarea type="text" rows="4" v-model="merchantRemover.Observacao"
                  :class="validatedRemoverForm | showValidateError(invalid)" />
                <div class="invalid-feedback d-block" v-if="validatedRemoverForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

          </d-form-row>

        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" :variant="!merchantBloquear.IsRemoved ? 'danger' : 'success'"
          @click="UpdateRemovedMerchant(!merchantRemover.IsRemoved)" :disabled="loadingUpdateRemove">
          <template v-if="!loadingUpdateRemove">
            {{ !merchantRemover.IsRemoved ? 'Remover' : 'Ativar' }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingUpdateRemove"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
    <b-modal id="mVisualizarAlerta" title="Visualização do Alerta" size="lg" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <div>
        <d-form-row>
          <d-col md="3" class="form-group">
            <label>Data do cadastro</label>
            <d-form-input type="text" v-bind:value="alertaSelecionado.DataCriacao | date('DD/MM/YYYY - HH:mm')"
              readonly />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Nome Merchant</label>
            <d-form-input type="text" v-model="alertaSelecionado.Merchant.Name" readonly />
          </d-col>
          <d-col md="3" class="form-group">
            <label>Documento Merchant</label>
            <the-mask class="form-control" type="text" :mask="['##.###.###/####-##']"
              v-model="alertaSelecionado.Merchant.Identity" readonly />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Origem</label>
            <b-form-textarea type="text" rows="4" :value="alertaSelecionado.Descricao" readonly />
          </d-col>
        </d-form-row>
        <d-form-row v-if="alertaSelecionado.IdResponsavelQsa != null">
          <d-col md="6" class="form-group">
            <label>CPF Responsável</label>
            <i v-b-tooltip.hover.bottom
              title="Caso o Responsável tenha sido encontrado na lista PEP o CPF deverá ser informado obrigatóriamente."
              class="fas fa-circle-info"></i>
            <the-mask class="form-control" type="text" :mask="['###.###.###-##']"
              v-model="alertaSelecionado.CPFResponsavel" :disabled="true" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Ação Tomada</label>
            <b-form-textarea type="text" rows="4" v-model="alertaSelecionado.AcaoTomada" :disabled="true" />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Usuario Ação</label>
            <d-form-input type="text" v-model="alertaSelecionado.UsuarioResolucao.Nome" readonly />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Data da Ação</label>
            <d-form-input type="text" v-bind:value="alertaSelecionado.DataResolucao | date('DD/MM/YYYY - HH:mm')"
              readonly />
          </d-col>
        </d-form-row>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="mFormMerchant" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          {{ modalTitle }}
          <template v-if="idMerchant">
            {{ infoMerchant.Name }}
            <template v-if="isSeeing">[{{ idMerchant }}]</template>
          </template>
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingMerchant"></loader>

      <nav v-if="!loadingMerchant" class="nav-steps" aria-label="breadcrumb">
        <ol style="background-color: #fff; padding: 0.75rem 0rem" class="breadcrumb">
          <li class="breadcrumb-item">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 0)"
              :class="[mCurrentStep == 0 ? 'active' : '']">{{
                infoMerchant.MerchantType.Code == "1" ? "Cliente" :
                  "Empresa"
              }}</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="infoMerchant.MerchantType.Code != '1'">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 1)"
              :class="[mCurrentStep == 1 ? 'active' : '']">Responsável</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="infoMerchant.MerchantType.Code != '1'">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 2)"
              :class="[mCurrentStep == 2 ? 'active' : '']">Contato Técnico</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="isSeeing || (!isSeeing)">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 3)"
              :class="[mCurrentStep == 3 ? 'active' : '']">Taxas</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 4)"
              :class="[mCurrentStep == 4 ? 'active' : '']">Informações</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"
              v-if="!isSeeing || (isSeeing && HasMerchantDocs) || HasMerchantCheckList"></i>
          </li>
          <li class="breadcrumb-item" v-if="HasMerchantDocs">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 5)"
              :class="[mCurrentStep == 5 ? 'active' : '']">Documentos</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="HasMerchantCheckList">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 6)"
              :class="[mCurrentStep == 6 ? 'active' : '']">CheckList</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <!-- <li class="breadcrumb-item" v-if="HasMerchantTickets">
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
            <a class="black-text" href="#" v-on:click="GoToStep($event, 7)"
              :class="[mCurrentStep == 7 ? 'active' : '']">Chamados</a>
          </li> -->
          <li class="breadcrumb-item" v-if="HasPerfilAtuacao">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 8)"
              :class="[mCurrentStep == 8 ? 'active' : '']">Perfil de Atuação</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item" v-if="HasMerchantBankData && isSeeing">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 9)"
              :class="[mCurrentStep == 9 ? 'active' : '']">Banco</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>

          </li>
          <li class="breadcrumb-item" v-if="HasMerchantPreview && isSeeing">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 10)"
              :class="[mCurrentStep == 10 ? 'active' : '']">Histórico</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>

          </li>
          <li class="breadcrumb-item" v-if="isSeeing">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 11)"
              :class="[mCurrentStep == 11 ? 'active' : '']">Limites</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>

          </li>
          <li class="breadcrumb-item" v-if="isSeeing">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 12)"
              :class="[mCurrentStep == 12 ? 'active' : '']">Alertas</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
          </li>
          <li class="breadcrumb-item">
            <!--Quando eu inverto o v-if aqui, ele estraga algum-->
            <a class="black-text" href="#" v-on:click="GoToStep($event, 13)"
              :class="[mCurrentStep == 13 ? 'active' : '']">Maquininhas</a>
            <i class="fas fa-angle-right mx-2" aria-hidden="true" v-if="!isSeeing"></i>

          </li>
          <li class="breadcrumb-item" v-if="!isSeeing">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 14)"
              :class="[mCurrentStep == 14 ? 'active' : '']">Confirmação</a>
          </li>
        </ol>
      </nav>

      <!--  Company - 0 -->
      <ValidationObserver tag="form" ref="CompanyStep">
        <div v-if="mCurrentStep === 0 && !loadingMerchant">
          <d-form-row>
            <d-col md="6">
              <div class="form-group">
                <label v-if="isSeeing || pOpened == null">Tipo de conta</label>
                <label v-else>Escolha o tipo de conta</label>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <select v-model="MerchantTypeCode" class="custom-select"
                    :class="validatedCompanyStep | showValidateError(invalid)" :disabled="isSeeing || pOpened == null">
                    <option :value="null" selected>Selecione</option>
                    <option v-for="type in merchantTypes" v-bind:value="type.Id" v-bind:key="type.Id">
                      {{ type.Name }}
                    </option>
                  </select>
                  <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
            <d-col md="6">
              <div class="form-group">
                <div id="input-optional">
                  <label>Parceiro</label>
                  <label class="optional">Opcional</label>
                </div>
                <d-select v-model="infoMerchant.Partner.Id" :value="0" :disabled="pOpened != null"
                  @change="onChangePartner">
                  <option :value="0" selected>Selecione</option>
                  <option v-for="partner in partners" v-bind:value="partner.Id" v-bind:key="partner.Id">
                    {{ partner.Name }}
                  </option>
                </d-select>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6">
              <div class="form-group">
                <div id="input-optional">
                  <label>SDR</label>
                  <label class="optional">Opcional</label>
                </div>
                <d-select v-model="infoMerchant.PartnerSDR.Id" :disabled="!isAllowChooseSDR || (pOpened != null)">
                  <option :value="0" selected>Selecione</option>
                  <option v-for="sdr in sdrs" v-bind:value="sdr.Id" v-bind:key="sdr.Id">
                    {{ sdr.Name }}
                  </option>
                </d-select>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6">
              <div class="form-group">
                <label v-if="!isSeeing">Escolha o tipo de faturamento</label>
                <label v-else>Tipo de faturamento</label>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <d-select v-model="infoMerchant.BillingType.Code"
                    :class="validatedCompanyStep | showValidateError(invalid)" :disabled="isSeeing">
                    <option :value="null" selected>Selecione</option>
                    <option v-for="type in billingTypes" v-bind:value="type.Code" v-bind:key="type.Code">
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
            <d-col md="6">
              <div class="form-group">
                <div id="input-optional">
                  <label v-if="!isSeeing">Escolha a negociação de recebimento</label>
                  <label v-else>Negociação de recebimento</label>
                  <label class="optional">Opcional</label>
                </div>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <d-select v-model="infoMerchant.TypeReceipt.Id"
                    :class="validatedCompanyStep | showValidateError(invalid)" :disabled="isSeeing">
                    <option :value="0" selected>Selecione</option>
                    <option v-for="type in typesReceipt" v-bind:value="type.Id" v-bind:key="type.Id">
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="3">
              <div class="form-group">
                <d-checkbox v-model="infoMerchant.IsTest" :disabled="isSeeing || pOpened != null || isValidated">
                  Utilizado para teste</d-checkbox>
              </div>
            </d-col>
            <d-col md="3">
              <div class="form-group">
                <d-checkbox v-model="infoMerchant.IsTrustable" :disabled="isSeeing">Cliente confiável</d-checkbox>
              </div>
            </d-col>
            <d-col :md="pOpened == null ? '1' : '2'">
              <div :class="(pOpened == null ? 'font-ckb ' : '') + 'form-group'">
                <d-checkbox v-model="infoMerchant.IsMEI" :disabled="isSeeing || isValidated"> MEI </d-checkbox>
              </div>
            </d-col>
            <d-col :md="pOpened == null ? '1' : '2'">
              <div :class="(pOpened == null ? 'font-ckb ' : '') + 'form-group'">
                <d-checkbox v-model="infoMerchant.IsAuthorizedAPI" :disabled="isSeeing || isValidated"> API
                </d-checkbox>
              </div>
            </d-col>
            <d-col :md="pOpened == null ? '1' : '2'" style="padding-left:0px !important">
              <div :class="(pOpened == null ? 'font-ckb ' : '') + 'form-group'">
                <d-checkbox v-model="infoMerchant.IsEnabled3DS" :disabled="isSeeing || isValidated"> 3DS </d-checkbox>
              </div>
            </d-col>
            <d-col md="3" v-if="pOpened == null">
              <div class="form-group">
                <d-checkbox v-model="infoMerchant.IsSendWelcomeEmail"> E-mail de boas vindas </d-checkbox>
              </div>
            </d-col>
          </d-form-row>
          <h4 v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'">Dados do cliente
          </h4>
          <h4 v-else>Dados da empresa</h4>
          <hr />
          <d-form-row v-if="isSeeing">
            <d-col md="6" class="form-group">
              <label>Data do cadastro</label>
              <d-form-input type="text" v-bind:value="infoMerchant.CreatedDate | date('DD/MM/YYYY - HH:mm')" readonly />
            </d-col>
            <d-col md="6" class="form-group">
              <label>Data de expiração da comissão</label>
              <d-form-input type="text" v-bind:value="infoMerchant.ExpirationCommissionDate | date('DD/MM/YYYY')"
                readonly />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'">Nome</label>
              <label v-else>Razão social</label>
              <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                <d-form-input v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'"
                  type="text" :class="validatedCompanyStep | showValidateError(invalid)" v-model="infoMerchant.Name"
                  @input="Update('ResponsibleName', $event)" :disabled="isSeeing || isValidated" />
                <d-form-input v-else type="text" :class="validatedCompanyStep | showValidateError(invalid)"
                  v-model="infoMerchant.Name" :disabled="isSeeing || isValidated" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'"
              class="form-group">
              <label>CPF</label>
              <ValidationProvider rules="required|min:11|identity" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedCompanyStep | showValidateError(invalid)" type="text"
                  :mask="['###.###.###-##']" v-model="infoMerchant.Identity"
                  @input="Update('ResponsibleIdentity', $event)" :disabled="isSeeing || isValidated" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col v-else md="6" class="form-group float-right">
              <div id="input-optional">
                <label>Nome fantasia</label>
                <label class="optional">Opcional</label>
              </div>
              <d-form-input type="text" v-model="infoMerchant.CommercialName" :disabled="isSeeing" />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" v-if="infoMerchant.MerchantType.Code != 1 && infoMerchant.MerchantType.Code != 5"
              class="form-group">
              <label>CNPJ</label>
              <ValidationProvider rules="required|min:14" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedCompanyStep | showValidateError(invalid)" type="text"
                  :mask="['##.###.###/####-##']" v-model="infoMerchant.Identity" :disabled="isSeeing || isValidated" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'"
              class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                <div class="input-group">
                  <d-form-input type="text" :class="validatedCompanyStep | showValidateError(invalid)"
                    v-model="infoMerchant.Email" :disabled="isSeeing || isValidated" />
                  <button type="button" class="btn btn-primary ml-2" v-b-tooltip.hover.bottom title="Reenviar e-mail"
                    @click="ConfirmResendEmail($event)" :disabled="isSeeing ||
                      loadingResendEmail ||
                      invalid ||
                      infoMerchant.Email == undefined ||
                      infoMerchant.Email == null ||
                      infoMerchant.Email.length == 0
                      ">
                    <template v-if="!loadingResendEmail">
                      <i class="fas fa-paper-plane"></i>
                    </template>
                    <template v-else>
                      <loader :small="true" :labelEnabled="false" :isLoading="loadingResendEmail"></loader>
                    </template>
                  </button>
                  <div class="form-group">
                    <d-checkbox v-model="infoMerchant.IsChangeAdmUser">
                      Alterar o e-mail do usuário administrador?</d-checkbox>
                  </div>
                </div>
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="3" v-if="infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5'"
              class="form-group">
              <label>Telefone</label>
              <ValidationProvider rules="max:20" v-slot="{ errors, invalid }">
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask id="parPhone" class="form-control" type="tel"
                    :class="validatedCompanyStep | showValidateError(invalid)"
                    :mask="['(##) #####-####', '(##) ####-####']" v-model="infoMerchant.ResponsiblePhone"
                    placeholder="Telefone" :disabled="isSeeing" />
                </d-input-group>
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col :class="[infoMerchant.MerchantType.Code == '1' || infoMerchant.MerchantType.Code == '5' ? '3' : '6']"
              class="form-group">
              <div id="input-optional">
                <label>Site</label>
                <label class="optional">Opcional</label>
              </div>
              <d-form-input type="text" v-model="infoMerchant.WebsiteUrl" :disabled="isSeeing" />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>CEP</label>
              <ValidationProvider rules="required|min:8" v-slot="{ errors, invalid }">
                <the-mask v-model="infoMerchant.Address.ZipCode"
                  :class="validatedCompanyStep | showValidateError(invalid)" :disabled="isSeeing"
                  @change.native="SearchByZipCode()" class="form-control" type="tel" :mask="['#####-###']" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="8" class="form-group">
              <label>Rua</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input :class="validatedCompanyStep | showValidateError(invalid)" type="text"
                  v-model="infoMerchant.Address.Street" :disabled="isSeeing" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>Número</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedCompanyStep | showValidateError(invalid)" type="tel"
                  :mask="['##########']" v-model="infoMerchant.Address.Number" :disabled="isSeeing" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="8" class="form-group">
              <label>Bairro</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input type="text" :class="validatedCompanyStep | showValidateError(invalid)"
                  v-model="infoMerchant.Address.District" :disabled="isSeeing" />
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <!-- Country -->
            <d-col md="4" class="form-group">
              <label for="parInputCountry">País</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select :class="validatedCompanyStep | showValidateError(invalid)"
                  v-model="infoMerchant.Address.Country.Name" :value="null" id="parInputCountry"
                  v-bind:disabled="isSeeing">
                  <option :value="null" selected>Selecione</option>
                  <option v-for="country in countries" v-bind:value="country.Name" v-bind:key="country.Id">
                    {{ country.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- State -->
            <d-col md="4" class="form-group">
              <label for="parInputState">Estado</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select :class="validatedCompanyStep | showValidateError(invalid)"
                  v-model="infoMerchant.Address.State.Initials" :value="null" id="parInputState"
                  v-bind:disabled="isSeeing">
                  <option :value="null" selected>Selecione</option>
                  <option v-for="state in states" v-bind:key="state.Initials" v-bind:value="state.Initials">
                    {{ state.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <!-- City -->
            <d-col md="4" class="form-group">
              <label for="parInputCity">Cidade</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select :class="validatedCompanyStep | showValidateError(invalid)"
                  v-model="infoMerchant.Address.City.Name" :value="null" id="parInputCity" v-bind:disabled="isSeeing">
                  <option :value="null" v-if="infoMerchant.Address.State.Initials == null" selected>Selecione</option>
                  <option :value="null" v-else selected>Selecione</option>
                  <option v-for="city in cities" v-bind:key="city.Name" v-bind:value="city.Name">
                    {{ city.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </div>
      </ValidationObserver>

      <!--  Owner - 1 -->
      <div v-show="mCurrentStep === 1">
        <h4>Dados do responsável</h4>
        <hr />
        <ValidationObserver ref="ResponsibleStep">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required:true|min:3" v-slot="{ errors, invalid }">
                <d-form-input :class="validatedResponsibleStep | showValidateError(invalid)" type="text"
                  v-model="infoMerchant.ResponsibleName" :disabled="isSeeing || isValidated" />
                <div class="invalid-feedback d-block" v-if="validatedResponsibleStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group float-right">
              <label>CPF</label>
              <ValidationProvider rules="required|min:11|identity" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedResponsibleStep | showValidateError(invalid)"
                  type="text" :mask="['###.###.###-##']" v-model="infoMerchant.ResponsibleIdentity"
                  :disabled="isSeeing || isValidated" />
                <div class="invalid-feedback d-block" v-if="validatedResponsibleStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>E-mail</label>




              <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                <div class="input-group">

                  <d-form-input :class="validatedResponsibleStep | showValidateError(invalid)" type="email"
                    v-model="infoMerchant.Email" :disabled="isSeeing || isValidated" />
                  <button type="button" class="btn btn-primary ml-2" v-b-tooltip.hover.bottom title="Reenviar e-mail"
                    @click="ConfirmResendEmail($event)" :disabled="isSeeing ||
                      loadingResendEmail ||
                      invalid ||
                      infoMerchant.Email == undefined ||
                      infoMerchant.Email == null ||
                      infoMerchant.Email.length == 0
                      ">
                    <template v-if="!loadingResendEmail">
                      <i class="fas fa-paper-plane"></i>
                    </template>
                    <template v-else>
                      <loader :small="true" :labelEnabled="false" :isLoading="loadingResendEmail"></loader>
                    </template>
                  </button>
                  <d-checkbox v-model="infoMerchant.IsChangeAdmUser" v-if="!isSeeing">
                    Alterar o e-mail do usuário administrador?
                  </d-checkbox>
                </div>
                <div class="invalid-feedback d-block" v-if="validatedResponsibleStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label for="parPhone">Telefone</label>
              <ValidationProvider rules="max:20" v-slot="{ errors, invalid }">
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask id="parPhone" class="form-control" type="tel"
                    :class="validatedResponsibleStep | showValidateError(invalid)"
                    :mask="['(##) #####-####', '(##) ####-####']" v-model="infoMerchant.ResponsiblePhone"
                    placeholder="Telefone" :disabled="isSeeing" />
                </d-input-group>
                <div class="invalid-feedback d-block" v-if="validatedResponsibleStep">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <!-- Contact - 2 -->
      <div v-show="mCurrentStep === 2">
        <h4>Contato técnico</h4>
        <hr />
        <ValidationObserver tag="form" ref="TechStep">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="max:100" v-slot="{ errors, invalid }">
                <d-form-input :class="validatedTechStep && ValidateFieldsTechResponsible() | showValidateError(invalid)"
                  :disabled="isSeeing" type="text" v-model="infoMerchant.TechName" />
                <div class="invalid-feedback d-block" v-if="validatedTechStep && ValidateFieldsTechResponsible()">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>CPF</label>
              <ValidationProvider rules="max:11|identity" v-slot="{ errors, invalid }">
                <the-mask :class="validatedTechStep && ValidateFieldsTechResponsible() | showValidateError(invalid)"
                  :disabled="isSeeing" :mask="['###.###.###-##']" class="form-control" type="tel"
                  v-model="infoMerchant.TechIdentity" />
                <div class="invalid-feedback d-block" v-if="validatedTechStep && ValidateFieldsTechResponsible()">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="max:100|email" v-slot="{ errors, invalid }">
                <div class="input-group">
                  <d-form-input
                    :class="validatedTechStep && ValidateFieldsTechResponsible() | showValidateError(invalid)"
                    :disabled="isSeeing" type="text" v-model="infoMerchant.TechEmail" />
                  <button type="button" class="btn btn-primary ml-2" v-b-tooltip.hover.bottom title="Reenviar e-mail"
                    @click="ConfirmResendTechEmail($event)" :disabled="isSeeing ||
                      loadingResendTechEmail ||
                      invalid ||
                      infoMerchant.TechEmail == undefined ||
                      infoMerchant.TechEmail == null ||
                      infoMerchant.TechEmail.length == 0
                      ">
                    <template v-if="!loadingResendTechEmail">
                      <i class="fas fa-paper-plane"></i>
                    </template>
                    <template v-else>
                      <loader :small="true" :labelEnabled="false" :isLoading="loadingResendTechEmail"></loader>
                    </template>
                  </button>
                </div>
                <div class="invalid-feedback d-block" v-if="validatedTechStep && ValidateFieldsTechResponsible()">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label for="techPhone">Telefone</label>
              <ValidationProvider rules="max:20" v-slot="{ errors, invalid }">
                <d-input-group seamless>
                  <d-input-group-text slot="prepend">
                    <i class="fas fa-phone-alt"></i>
                  </d-input-group-text>
                  <the-mask :class="validatedTechStep && ValidateFieldsTechResponsible() | showValidateError(invalid)"
                    :disabled="isSeeing" :mask="['(##) #####-####', '(##) ####-####']" class="form-control"
                    id="techPhone" type="tel" v-model="infoMerchant.TechPhone" />
                </d-input-group>
                <div class="invalid-feedback d-block" v-if="validatedTechStep && ValidateFieldsTechResponsible()">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <!-- Taxes - 3 -->
      <div v-if="mCurrentStep === 3">
        <h4>Taxas</h4>
        <hr v-if="!isSeeing && isMerchantRoot" />
        <div v-if="!isSeeing && isMerchantRoot">
          <ValidationObserver tag="form" @submit.prevent="AddPaymentMethod" ref="TaxValidationForm">
            <d-form-row>
              <d-col md="6">
                <div class="form-group">
                  <label>Escolha o método de pagamento</label>
                  <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                    <d-select v-model="selected_payment" :class="validatedTaxForm | showValidateError(invalid)">
                      <option :value="null">Selecione</option>
                      <option v-for="method in paymentMethods" v-bind:value="method.Code" v-bind:key="method.Code">
                        {{ method.Name }}
                      </option>
                    </d-select>
                    <div class="invalid-feedback d-block" v-if="validatedTaxForm">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </div>
              </d-col>
              <d-col md="6" class="d-flex align-items-center">
                <d-form-checkbox class="ml-1" v-model="activeTaxConfig.IsEnabled" id="checkPymtActive">
                  Habilitado
                </d-form-checkbox>
              </d-col>
            </d-form-row>

            <d-form-row>
              <d-col md="6" class="form-group">
                <label>Tipo de taxa</label>
                <d-select v-model="activeTaxConfig.TaxType.Code">
                  <option value="1">Percentual</option>
                  <option value="2">Valor</option>
                </d-select>
              </d-col>
              <d-col md="6" class="form-group">
                <label>{{ activeTaxConfig.TaxType.Code == 1 ? "Percentual" : "Valor" }}</label>
                <ValidationProvider rules="required|min_value:0.01" v-slot="{ errors, invalid }">
                  <decimal-field v-model="activeTaxConfig.Amount" :class="validatedTaxForm | showValidateError(invalid)"
                    :type="activeTaxConfig.TaxType.Code == 1 ? 'percentage' : 'currency'" />
                  <div class="invalid-feedback d-block" v-if="validatedTaxForm">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
          </ValidationObserver>

          <d-form-row>
            <b-col>
              <b-button class="float-right" variant="success" size="sm" @click="AddPaymentMethod($event)">
                Incluir Taxa
              </b-button>
            </b-col>
          </d-form-row>
        </div>
        <br />

        <table class="table mb-0" :key="tableKey" v-if="infoMerchant.Configuration.MerchantPaymentMethod.length > 0">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th>Método de Pagamento</th>
              <th>Taxa</th>
              <th v-if="!isMerchantRoot">Sobretaxa</th>
              <th class="text-center">Parcela inicial</th>
              <th class="text-center">Parcela final</th>
              <th>Habilitado</th>
              <th v-if="isSeeing">Bloqueado</th>
              <th v-if="!isSeeing && $isAuthorize('BlockList', 'Adicionar')" class="actions"></th>
              <th v-if="!isSeeing && isMerchantRoot" class="actions"></th>
              <th v-if="!isSeeing && isMerchantRoot" class="actions"></th>
            </tr>
          </thead>

          <tbody v-if="isMerchantRoot">
            <template v-for="(pymtMethod, idxPymt) in infoMerchant.Configuration.MerchantPaymentMethod">
              <template v-if="pymtMethod.ListTax.length > 1">
                <tr v-for="(tax, idxTax) in pymtMethod.ListTax" v-bind:key="'taxIdx' + idxTax">
                  <td v-if="idxTax == parseInt(pymtMethod.ListTax.length / 2, 10)"
                    :class="idxTax > 0 ? 'tr-hidden' : ''">
                    {{ pymtMethod.PaymentMethod.Name }}
                  </td>
                  <td v-else :class="idxTax > 0 ? 'tr-hidden' : ''"></td>
                  <td v-if="tax.TaxType.Code == 1">
                    {{ tax.Amount | percentage }}
                  </td>
                  <td v-else>{{ tax.Amount | currency }}</td>
                  <td class="text-center">{{ tax.InitialInstallment }}</td>
                  <td class="text-center">{{ tax.EndInstallment }}</td>
                  <td class="text-center">
                    <i :class="[pymtMethod.IsEnabled ? 'fas fa-check fa-green' : 'fas fa-minus']"></i>
                  </td>
                  <td v-if="isSeeing" class="text-center">
                    <i :class="[pymtMethod.IsSecurityApproved ? 'fas fa-lock-open' : 'fas fa-lock red']"></i>
                  </td>
                  <td v-if="!isSeeing && $isAuthorize('BlockList', 'Adicionar')"
                  style="padding-right: 0px;">
                    <div class="text-right">
                      <b-button size="sm" variant="outline-secondary"
                        @click="BlockPaymentMethod(idxPymt)" v-b-tooltip.hover
                        :title="[pymtMethod.IsSecurityApproved ? 'Bloquear' : 'Desbloquear']"
                        :style="[pymtMethod.IsSecurityApproved ? 'color: green; border-color: green' : 'color: red; border-color: red']">
                        <i :class="[pymtMethod.IsSecurityApproved ? 'fas fa-unlock' : 'fas fa-lock']"></i>
                      </b-button>
                    </div>
                  </td>

                  <td v-if="!isSeeing">
                    <div class="text-center">
                      <b-button size="sm" :disabled="idxTax !== 0" variant="outline-secondary"
                        @click="OpenMTaxModify(idxPymt, idxTax)"
                        v-b-tooltip.hover
                        title="Editar taxa">
                        <i class="fas fa-highlighter"></i>
                      </b-button>
                    </div>
                  </td>

                  <td v-if="!isSeeing"
                  style="padding-left: 0px;">
                    <div class="text-left">
                      <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover
                        title="Utilizar a opção de desabilitar"
                        @click="RemovePaymentMethod(pymtMethod.PaymentMethod.Code, idxTax)">
                        <i class="fas fa-trash-alt" />
                      </b-button>
                    </div>
                  </td>
                </tr>
              </template>

              <template v-else>
                <tr v-bind:key="pymtMethod.PaymentMethod.Code">
                  <td>{{ pymtMethod.PaymentMethod.Name }}</td>
                  <td v-if="pymtMethod.ListTax[0].TaxType.Code == 1">
                    {{ pymtMethod.ListTax[0].Amount | percentage }}
                  </td>
                  <td v-else>{{ pymtMethod.ListTax[0].Amount | currency }}</td>
                  <td class="text-center" v-if="pymtMethod.ListTax[0].TaxType.Code == 1 && !isMerchantRoot">
                    {{ pymtMethod.ListTax[0].Amount | percentage }}
                  </td>
                  <td class="text-center" v-else-if="!isMerchantRoot">{{ pymtMethod.ListTax[0].Amount | currency }}</td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td class="text-center">
                    <i :class="[pymtMethod.IsEnabled ? 'fas fa-check fa-green' : 'fas fa-minus']"></i>
                  </td>
                  <td v-if="isSeeing" class="text-center">
                    <i :class="[pymtMethod.IsSecurityApproved ? 'fas fa-lock-open' : 'fas fa-lock red']"></i>
                  </td>
                  <td v-if="!isSeeing && $isAuthorize('BlockList', 'Adicionar')"
                  style="padding-right: 0px;">
                    <div class="text-right">
                      <b-button size="sm" variant="outline-secondary"
                        @click="BlockPaymentMethod(idxPymt)" v-b-tooltip.hover
                        :title="[pymtMethod.IsSecurityApproved ? 'Bloquear' : 'Desbloquear']"
                        :style="[pymtMethod.IsSecurityApproved ? 'color: green; border-color: green' : 'color: red; border-color: red']">
                        <i :class="[pymtMethod.IsSecurityApproved ? 'fas fa-unlock' : 'fas fa-lock']"></i>
                      </b-button>
                    </div>
                  </td>

                  <td v-if="!isSeeing">
                    <div class="text-center">
                      <b-button size="sm" variant="outline-secondary"
                        @click="OpenMTaxModify(idxPymt)"
                        v-b-tooltip.hover
                        title="Editar taxa">
                        <i class="fas fa-highlighter"></i>
                      </b-button>
                    </div>
                  </td>

                  <td v-if="!isSeeing"
                  style="padding-left: 0px;">
                    <div class="text-left">
                      <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover
                        title="Utilizar a opção de desabilitar"
                        @click="RemovePaymentMethod(pymtMethod.PaymentMethod.Code)">
                        <i class="fas fa-trash-alt" />
                      </b-button>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>

          <tbody v-else>
            <template v-for="(pymtMethod, idxPymt) in infoMerchantSplitTax">
              <tr v-for="(tax, idxTax) in pymtMethod.Taxes" :key="'taxIdx' + idxPymt + idxTax">
                <td v-if="idxTax == 0">{{ pymtMethod.PaymentMethod.Name }}</td>
                <td v-else></td>
                <td class="text-center" v-if="tax.TaxType.Code == 1">
                  <span
                    v-if="idxTax == 0 || pymtMethod.Taxes[idxTax].MarketPlaceTax != pymtMethod.Taxes[idxTax - 1].MarketPlaceTax">
                    {{ tax.MarketPlaceTax | percentage }}
                  </span>
                </td>
                <td class="text-center" v-else>
                  <span v-if="idxTax == 0">{{ tax.MarketPlaceTax | currency }}</span>
                </td>
                <td class="text-center" v-if="tax.TaxTypeSplit.Code == 1">
                  <span v-if="tax.Tax > 0">{{ tax.Tax | percentage }}</span>
                </td>
                <td class="text-center" v-else>
                  <span v-if="tax.Tax > 0">{{ tax.Tax | currency }}</span>
                </td>
                <td class="text-center">
                  <span v-if="tax.InitialInstallment > 0">{{ tax.InitialInstallment }}</span>
                </td>
                <td class="text-center">
                  <span v-if="tax.EndInstallment > 0">{{ tax.EndInstallment }}</span>
                </td>
                <td class="text-center">
                  <i :class="[pymtMethod.PaymentMethod.IsEnabled ? 'fas fa-check fa-green' : 'fas fa-minus']"></i>
                </td>
                <td class="text-center" v-if="isSeeing">
                  <i :class="[pymtMethod.PaymentMethod.IsSecurityApproved ? 'fas fa-lock-open' : 'fas fa-lock red']"></i>
                </td>
                <td v-if="!isSeeing" class="text-right">
                  <b-button v-if="$isAuthorize('BlockList', 'Adicionar')" size="sm" variant="outline-secondary"
                    @click="BlockPaymentMethod(idxPymt)" v-b-tooltip.hover
                    :title="pymtMethod.PaymentMethod.IsSecurityApproved ? 'Bloquear' : 'Desbloquear'"
                    :style="pymtMethod.PaymentMethod.IsSecurityApproved ? 'color: green; border-color: green' : 'color: red; border-color: red'">
                    <i :class="[pymtMethod.PaymentMethod.IsSecurityApproved ? 'fas fa-unlock' : 'fas fa-lock']"></i>
                  </b-button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- AdditionalInformation - 4 -->
      <div v-if="mCurrentStep === 4">
        <h4>Informações</h4>
        <div>
          <d-form-row>
            <d-col class="col-12">
              <d-form-radio :value="false" v-model="infoMerchant.AdditionalInformation.IsOperation"
                :disabled="isSeeing">
                Em construção
              </d-form-radio>
              <d-form-radio :value="true" v-model="infoMerchant.AdditionalInformation.IsOperation" :disabled="isSeeing">
                Em operação
              </d-form-radio>
            </d-col>
          </d-form-row>
          <d-form-row v-if="infoMerchant.AdditionalInformation.IsOperation">
            <d-col class="col-4">
              <br />
              <label>Valor de faturamento mensal</label>
              <currency-input class="form-control" v-model="infoMerchant.AdditionalInformation.GrossBillingAmount"
                :disabled="isSeeing" />
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col class="col-12">
              <br />
              <h5>Plataforma</h5>
              <hr />
              <d-checkbox v-model="infoMerchant.AdditionalInformation.IsInterface" :disabled="isSeeing">
                Via interface gráfica
              </d-checkbox>
              <d-checkbox v-model="infoMerchant.AdditionalInformation.IsApi" :disabled="isSeeing">Via API</d-checkbox>
              <d-checkbox v-model="infoMerchant.AdditionalInformation.IsOtherSoftware" :disabled="isSeeing">
                Através de um software de terceiro
              </d-checkbox>
              <d-checkbox v-model="infoMerchant.AdditionalInformation.IsMarketplace" :disabled="isSeeing">
                Marketplace
              </d-checkbox>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col class="col-12">
              <br />
              <h5>Banco principal</h5>
              <hr />
              <d-col md="6">
                <div class="form-group">
                  <label v-if="!isSeeing">Selecione o banco principal</label>
                  <label v-else>Banco principal</label>
                  <d-select v-model="infoMerchant.ProviderPrimary.Id" :disabled="isSeeing">
                    <option :value="0" selected>Selecione</option>
                    <option v-for="gateway in gateways" v-bind:value="gateway.Id" v-bind:key="gateway.Id">
                      {{ gateway.Name }}
                    </option>
                  </d-select>
                </div>
              </d-col>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col class="col-12">
              <br />
              <h5>Observação</h5>
              <hr />
              <d-col md="12" class="form-group">
                <ValidationProvider rules="max:500" v-slot="{ errors, invalid }">
                  <b-form-textarea :class="validatedCompanyStep | showValidateError(invalid)" type="text"
                    v-model="infoMerchant.AdditionalInformation.Observation" :disabled="isEdit" />
                  <div class="invalid-feedback d-block" v-if="validatedCompanyStep">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-col>
          </d-form-row>
          <d-form-row v-if="infoMerchant.AdditionalInformation.UserInternal">
            <d-col class="col-12">
              <br />
              <h5>Usuário</h5>
              <hr />
              <d-col md="12">
                <div class="form-group">
                  <d-form-input type="text" v-model="infoMerchant.AdditionalInformation.UserInternal.Name"
                    :disabled="isEdit" />
                </div>
              </d-col>
            </d-col>
          </d-form-row>
        </div>
      </div>

      <!-- MerchantDocs - 5 -->
      <div v-if="mCurrentStep === 5">
        <div>
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0"></th>
                <th scope="col" class="border-0">Documento</th>
                <th scope="col" class="border-0">Data de criação</th>
                <th scope="col" class="border-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(merchantDoc, index) in merchantDocs" :key="index">
                <td></td>
                <td>{{ merchantDoc.MerchantDocType.Name }}</td>
                <td>{{ merchantDoc.CreatedDate | date }}</td>
                <td>
                  <b-button class="btn btn-outline-secondary btn-sm" v-b-tooltip.hover title="Download"
                    :disabled="loadingDownload" v-on:click="DownloadMerchantDoc($event, index)">
                    <i v-if="!loadingDownload" class="fas fa-file-download mr-0"></i>
                    <template v-else>
                      <loader :small="true" :isLoading="loadingDownload"></loader>
                    </template>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- CheckList - 6 -->
      <div v-if="mCurrentStep === 6 && isSeeing">
        <h4>CheckList</h4>
        <hr />
        <div>
          <d-form-row>
            <d-col md="6" class="form-group">
              <h5>Gerados em Sandbox</h5>
            </d-col>
            <d-col md="3" class="form-group">
              <h5>Datas da geração</h5>
            </d-col>
          </d-form-row>
          <div v-for="(checklist, index) in this.merchantCheckLists" :key="index">
            <d-form-row>
              <d-col md="6" class="form-group">
                <d-form-checkbox v-model="checklist.IsSandBoxSandBox" :disabled="isSeeing">{{
                  checklist.PaymentMethod.Name
                }}</d-form-checkbox>
              </d-col>
              <d-col md="3" class="form-group">
                <date-field v-model="checklist.CreatedDateSandBox" :disabled="isSeeing"
                  v-if="checklist.IsSandBoxSandBox" />
              </d-col>
            </d-form-row>
          </div>
        </div>
        <hr />
        <div>
          <d-form-row>
            <d-col md="6" class="form-group">
              <h5>Gerados em produção</h5>
            </d-col>
            <d-col md="3" class="form-group">
              <h5>Datas da geração</h5>
            </d-col>
          </d-form-row>
          <div v-for="(checklist, index) in this.merchantCheckLists" :key="index">
            <d-form-row>
              <d-col md="6" class="form-group">
                <d-form-checkbox v-model="checklist.IsSandBoxProd" :disabled="isSeeing">{{
                  checklist.PaymentMethod.Name
                }}</d-form-checkbox>
              </d-col>
              <d-col md="3" class="form-group">
                <date-field v-model="checklist.CreatedDateProd" :disabled="isSeeing"
                  v-if="checklist.IsSandBoxProd && checklist.IsPaidProd" />
              </d-col>
            </d-form-row>
          </div>
        </div>
        <hr />
        <div>
          <d-form-row>
            <d-col md="6" class="form-group">
              <h5>Pagos em produção</h5>
            </d-col>
            <d-col md="3" class="form-group">
              <h5>Datas da geração</h5>
            </d-col>
          </d-form-row>
          <div v-for="(checklist, index) in this.merchantCheckLists" :key="index">
            <d-form-row>
              <d-col md="6" class="form-group">
                <d-form-checkbox v-model="checklist.IsPaidProdPaid" :disabled="isSeeing">{{
                  checklist.PaymentMethod.Name
                }}</d-form-checkbox>
              </d-col>
              <d-col md="3" class="form-group">
                <date-field v-model="checklist.PaymentDateProdPaid" :disabled="isSeeing"
                  v-if="checklist.IsPaidProdPaid" />
              </d-col>
            </d-form-row>
          </div>
        </div>
        <hr />
        <div>
          <d-form-row>
            <d-col md="4" class="form-group">
              <span>Primeira venda avulsa</span>
              <date-field v-model="this.merchantCheckListDates.FirstSingleSaleDate" :disabled="isSeeing" />
            </d-col>
            <d-col md="2" class="form-group"></d-col>
            <d-col md="4" class="form-group">
              <span>Última transação</span>
              <date-field v-model="this.merchantCheckListDates.LastCreateDate" :disabled="isSeeing" />
            </d-col>
          </d-form-row>
        </div>
      </div>

      <!-- Tickets / Chamados - 7 -->
      <!-- <div v-if="mCurrentStep === 7 && HasMerchantTickets">
        <table class="table mb-0" :key="ticketsTableKey">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th scope="col" class="border-0 text-left">Número</th>
              <th scope="col" class="border-0 text-center">Origem</th>
              <th scope="col" class="border-0 text-center">Status</th>
              <th scope="col" class="border-0 text-center">Data do cadastro</th>
              <th scope="col" class="border-0 text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ticket, index) in merchantTickets" :key="'ticket-' + index + '-' + ticket.Id">
              <td class="text-left">{{ ticket.Id }}</td>
              <td class="text-center">
                {{ GetGenericName("TicketSourceList", ticket.Source.Code) }}
              </td>
              <td class="text-center">
                {{ GetGenericName("TicketStatusList", ticket.Status.Code) }}
              </td>
              <td class="text-center">{{ ticket.CreatedDate | date }}</td>
              <td class="text-right">
                <div class="dropdown">
                  <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Opções
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#" v-on:click="OpenTicketRegister($event, { IdTicket: ticket.Id })">
                      <i class="fas fa-eye mr-2"></i> Visualizar
                    </a>
                    <a class="dropdown-item" href="#" v-if="ticket.Status.Code != '5'"
                      v-on:click="OpenTicketRegister($event, { IdTicket: ticket.Id, Mode: 'finish' })">
                      <i class="fas fa-check mr-2"></i> Finalizar
                    </a>
                    <a class="dropdown-item" href="#" v-if="ticket.Status.Code == '5'"
                      v-on:click="OpenTicketRegister($event, { IdTicket: ticket.Id, Mode: 'reopen' })">
                      <i class="fas fa-lock-open mr-2"></i> Reabrir
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <!-- CNAE - 8 -->
      <!-- CNAE - 8 -->
      <div v-if="mCurrentStep === 8 && HasPerfilAtuacao">
        <div>
          <h4>Classificação</h4>
          <hr>
          <br/>
          <template v-if="merchantClassificacao">
            <d-form-row>
              <d-col md="6" class="form-group">
                <label>Nicho</label>
                <d-form-input type="text" :value="merchantClassificacao.Nicho ? merchantClassificacao.Nicho.Nome : '-'" readonly />
              </d-col>
              <d-col md="6" class="form-group">
                <label>Segmento</label>
                <d-form-input type="text" :value="merchantClassificacao.Segmento ? merchantClassificacao.Segmento.Nome : '-'" readonly />
              </d-col>
            </d-form-row>
          </template>
          <div v-else class="text-center py-3 text-muted">
            <i class="fas fa-tag mr-2"></i>
            Este cliente ainda não possui uma classificação de nicho e segmento.
          </div>
        </div>

        <div v-if="HasMerchantCnaes">
        <h4>Atividade Econômica</h4>
        <hr>
        <br />
        <d-form-row>
          <d-col md="6">
            <div class="form-group">
              <div id="input-optional">
                <label>Atividade Econômica</label>
                <!-- <label class="optional">Opcional</label> -->
              </div>

              <d-select v-model="infoMerchant.MerchantAntifraudeCategoria.AntifraudeCategoria.Id" :disabled="isSeeing">
                <option :value="0" selected>Selecione</option>
                <option v-for="antifraudeCategory in listMerchantAntifraudeCategory"
                  v-bind:value="antifraudeCategory.Id" v-bind:key="antifraudeCategory.Id">
                  {{ antifraudeCategory.Category }}
                </option>
              </d-select>
              <div style="margin-left:5%;font-size: 12px;color:red;" v-if="!isSeeing">*Se a chave não for selecionada,
                será
                usado o CNAE principal
              </div>
            </div>
          </d-col>
        </d-form-row>

        <h4>CNAEs</h4>
        <hr>
        <br />

        <table class="table mb-0" :key="tableKey" v-if="merchantCnaes.length > 0">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th>Código</th>
              <th>Nome</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(cnae, index) in merchantCnaes" :key="index">
              <td>{{ cnae.Code }}</td>
              <td class="text-left td-with-subs">
                <div>{{ cnae.Description }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      <!-- Bank - 9 -->
      <div v-if="mCurrentStep === 9 && HasMerchantBankData">
        <h4>Dados bancários</h4>
        <hr v-if="isSeeing" />
        <br />

        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Código</label>
            <d-form-input type="text" v-model="infoMerchant.BankData.Bank.Code" readonly />
          </d-col>
          <d-col md="6" class="form-group float-right">
            <label>Banco</label>
            <d-form-input type="text" v-model="infoMerchant.BankData.Bank.Name" readonly />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="3" class="form-group">
            <label>Agência</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.BankData.BankAgency" readonly />
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Dígito</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.BankData.BankAgencyDigit" readonly />
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Conta</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.BankData.BankAccount" readonly />
            </div>
          </d-col>
          <d-col md="3" class="form-group">
            <label>Dígito</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.BankData.BankAccountDigit" readonly />
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Tipo de Conta</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.BankData.AccountType.Name" readonly />
            </div>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Frequência</label>
            <div class="input-group">
              <d-form-input type="text" v-model="infoMerchant.MerchantPaymentDate.PlanFrequence.Name" readonly />
            </div>
          </d-col>
        </d-form-row>
      </div>

      <!-- History - 10 -->
      <div v-if="mCurrentStep === 10 && HasMerchantPreview">
        <h4>Histórico</h4>
        <hr v-if="!isSeeing" />
        <br />

        <table class="table mb-0" :key="tableKey" v-if="merchantsPreviewHistory.length > 0">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th>Situação</th>
              <th class="text-center">Motivo Interno</th>
              <th class="text-center">Usuário</th>
              <th>Data de Atualização</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(infoPreviewHistory, index) in merchantsPreviewHistory" :key="index">
              <td>{{ infoPreviewHistory.MerchantPreviewStatus.Name }}</td>
              <td class="text-center">
                <div>{{ infoPreviewHistory.ReasonInternal || "-" }}</div>
              </td>
              <td class="text-center">
                <div>{{ infoPreviewHistory.UserInternal.Name || "-" }}</div>
              </td>
              <td>
                <div>
                  {{ infoPreviewHistory.ChangedDate | date("DD/MM/YYYY HH:mm:ss") }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Limits - 11 -->
      <div v-if="mCurrentStep === 11">
        <h4>Limites</h4>
        <hr v-if="isSeeing" />
        <br />

        <ValidationObserver tag="form" ref="LimitsStep">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Percentual máximo de antecipação</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantLimits | showValidateError(invalid)"
                  v-model="infoMerchantLimits.AntecipacaoPercentualMaximo" type="percentage" :maxDecimalPlaces="1"
                  disabled />
                <div class="invalid-feedback d-block" v-if="validatedMerchantLimits">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Percentual máximo de disputa</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantLimits | showValidateError(invalid)"
                  v-model="infoMerchantLimits.DisputaPercentualMaximo" type="percentage" :maxDecimalPlaces="1"
                  disabled />
                <div class="invalid-feedback d-block" v-if="validatedMerchantLimits">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <!-- Alertas - 12 -->

      <div v-if="mCurrentStep === 12">
        <h4>Alertas</h4>
        <hr v-if="isSeeing" />

        <div v-if="isSeeing">
          <table class="table mb-0" :key="tableKey">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th>Id</th>
                <th>Data Criação</th>
                <th>Descrição</th>
                <th>Data Resolução</th>
                <th>Usuário</th>
                <th class="actions"></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(alertaMerchant, index) in listaAlertasMerchant" :key="index">
                <td class="text">{{ alertaMerchant.Id }}</td>
                <td class="text">{{ alertaMerchant.DataCriacao | date("DD/MM/YYYY - HH:mm") }}</td>
                <td class="text">{{ alertaMerchant.Descricao }}</td>
                <td class="text">{{ alertaMerchant.DataResolucao | date("DD/MM/YYYY - HH:mm") }}</td>
                <td class="text">
                  {{ alertaMerchant.UsuarioResolucao.Id > 0 ? alertaMerchant.UsuarioResolucao.Nome : "-" }}
                </td>
                <td class="text">
                  <b-button variant="primary" class="btn btn-light border border-secondary" v-b-tooltip.hover.bottom
                    title="Visualizar" @click="OpenModalAlerta(alertaMerchant)">
                    <i v-bind:class="{
                      'fas fa-eye': alertaMerchant.UsuarioResolucao.Id > 0,
                      'fas fa-warning fa-red': alertaMerchant.UsuarioResolucao.Id <= 0,
                    }"></i>
                  </b-button>
                </td>
              </tr>
              <tr v-if="
                listaAlertasMerchant == undefined || listaAlertasMerchant == null || listaAlertasMerchant.length == 0
              ">
                <td colspan="8" style="text-align: center;">Sem registros</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Maquininhas - 13 -->
      <div v-show="mCurrentStep === 13">
        <h4>Maquininhas</h4>
        <hr />
        <br />

        <ValidationObserver tag="form" ref="MaquininhasStep">
          <d-checkbox v-model="infoMerchant.MaquinaMensalidade.Ativo" :disabled="isSeeing">
            Cobrar Aluguel?
          </d-checkbox>
          <div style="margin-left:5%;font-size: 12px;color:red;">*Só será cobrado o aluguel se a flag estiver marcada.
          </div>
          <br>
          <d-form-row :disabled="!infoMerchant.MaquinaMensalidade.Ativo">
            <d-col md="6" class="form-group">
              <label>Valor do aluguel de maquininhas</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantMaquininhas | showValidateError(invalid)"
                  v-model="infoMerchant.MaquinaMensalidade.ValorAluguel" type="currency"
                  :disabled="isSeeing || !infoMerchant.MaquinaMensalidade.Ativo" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantMaquininhas">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label> TPV para isenção de aluguel das maquininhas</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantMaquininhas | showValidateError(invalid)"
                  v-model="infoMerchant.MaquinaMensalidade.ValorTpvParaIsencao" type="currency"
                  :disabled="isSeeing || !infoMerchant.MaquinaMensalidade.Ativo" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantMaquininhas">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>

        <d-checkbox v-model="infoMerchant.MaquinaMensalidade.TpvCompartilhado" :disabled="pOpened != null">
          TPV compartilhado para cálculo de isenção de aluguel
        </d-checkbox>
        <div style="margin-left:5%;font-size: 12px;color:red;">*Se o TPV for compartilhado, será somado o TPV de todas as maquininhas<br> para calcular quantas serão isentas de aluguel, caso o contrário o aluguel<br> será calculado baseado no TPV de cada máquina.
        </div>
      </div>

      <!-- Confirm - 14 -->
      <div v-if="mCurrentStep === 14">
        <h4>Confirmação</h4>
        <div>
          <d-form-row>
            <d-col class="col-12">
              <p class="font-weight-bold mb-4">Informações do cliente</p>
              <p class="account-type mb-2">Tipo de conta: {{ MerchantTypeName }}</p>
              <p class="mb-2">
                Responsável: {{ infoMerchant.ResponsibleName }} -
                {{ ResponsibleIdentity }}
              </p>
              <p v-if="infoMerchant.TechName" class="mb-2">
                Responsável Técnico: {{ infoMerchant.TechName }} -
                {{ ResponsibleTechIdentity }}
              </p>
              <p class="mb-4">Telefone: {{ infoMerchant.ResponsiblePhone | phone }}</p>
              <p class="mb-4">E-mail: {{ infoMerchant.Email }}</p>
              <p class="mb-5">
                Endereço: {{ infoMerchant.Address.Street }}, {{ infoMerchant.Address.Number }} -
                {{ infoMerchant.Address.District }}, {{ infoMerchant.Address.City.Name }} -
                {{ infoMerchant.Address.State.Initials }} -
                {{ infoMerchant.Address.Country.Name }}
              </p>
            </d-col>
          </d-form-row>
        </div>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" @click="BackStep()"
            :disabled="mCurrentStep === 0 || loadingCreateUpdate">
            <i class="fas fa-arrow-left"></i>
          </b-button>

          <b-button size="sm" class="btn btn-secondary" @click="ProcessNextStep()"
            :disabled="mCurrentStep == 13 && isSeeing" v-if="mCurrentStep !== 14">
            <i class="fas fa-arrow-right"></i>
          </b-button>
          <b-button type="button" class="btn btn-success" :disabled="loadingCreateUpdate || isSeeing"
            v-on:click="OpenModalMotivoAtualizacao()" v-if="mCurrentStep === 14">
            <template v-if="!loadingCreateUpdate">
              {{ pOpened != null ? " Salvar alterações" : " Cadastrar cliente" }}
            </template>
            <template v-else>
              <loader :small="true" :isLoading="loadingCreateUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal size="md" id="mFormMotivoAtualizacao" title="Atualizar Merchant" :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingUpdateBlocked">
        <loader :is-loading="loadingUpdateBlocked"></loader>
      </div>

      <div v-else>
        <ValidationObserver tag="form" ref="AtualizarMerchantForm">
          <p>
            Você tem certeza que deseja atualizar o merchant
            <b>{{ this.infoMerchant.Name }} ({{ this.infoMerchant.Identity }})</b>?
          </p>

          <d-form-row>
            <d-col md="7" class="form-group">
              <label>Usuário</label>
              <d-form-input type="text" v-model="$getUserInternal().Name" readonly />
            </d-col>

            <d-col md="5" class="form-group">
              <label>Data</label>
              <d-form-input type="text" v-bind:value="new Date() | date('DD/MM/YYYY - HH:mm')" readonly />
            </d-col>

            <d-col md="12">
              <label>Motivo da Atualização</label>
              <ValidationProvider rules="required|min:15" v-slot="{ errors, invalid }">
                <b-form-textarea type="text" rows="4" v-model="merchantAtualizar.Observacao"
                  :class="validatedAtualizarForm | showValidateError(invalid)" />
                <div class="invalid-feedback d-block" v-if="validatedAtualizarForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <!-- Rodapé -->
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" :variant="(merchantAtualizar.Observacao.length >= 15) ? 'success' : 'danger'"
          @click="ConfirmarAtualizacao()" :disabled="loadingUpdateBlocked">
          <template v-if="!loadingUpdateBlocked">
            Atualizar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingUpdateBlocked"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>


    <div>
      <a v-if="$isAuthorize('Merchant', 'List') && !isMerchantRoot" href="#" v-b-tooltip.hover style="top: 75%"
        class="btn-float primary" title="Voltar para Raiz" v-on:click="ReturnToRootFilter()">
        <i class="fas fa-long-arrow-alt-left"></i>
      </a>
    </div>

    <b-modal id="mTaxModify" title="Editar" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Tipo de taxa</label>
          <d-select v-model="infoTax.TaxType.Code">
            <option value="1">Percentual</option>
            <option value="2">Valor</option>
          </d-select>
        </d-col>
        <d-col md="6">
          <label>{{ infoTax.TaxType.Code == 1 ? "Percentual" : "Valor" }}</label>
          <decimal-field v-model="infoTax.Amount" :disabled="isSeeing"
            :type="infoTax.TaxType.Code == 1 ? 'percentage' : 'currency'" />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="d-flex align-items-start">
          <d-form-checkbox class="ml-1" v-model="infoTax.PaymentIsEnabled" id="checkTaxPymtIsActive">
            Habilitado
          </d-form-checkbox>
        </d-col>
      </d-form-row>

      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button size="sm" variant="success" @click="ModifyTax()">Alterar</b-button>
      </template>
    </b-modal>

    <b-modal id="mFormUpdatePartner" title="Solicitar alteração de parceiro" size="lg" centered
      :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModalPartner">
        <loader :is-loading="loadingModalPartner"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="UpdatePartnerForm">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Data do cadastro</label>
              <d-form-input type="text" v-bind:value="infoMerchantPartner.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                readonly />
            </d-col>
            <d-col md="6" class="form-group">
              <label>Origem</label>
              <d-form-input type="text" :value="infoMerchantPartner.SourceDescription" readonly />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label
                v-if="infoMerchantPartner.MerchantType.Code == '1' || infoMerchantPartner.MerchantType.Code == '5'">
                Nome
              </label>
              <label v-else>Razão social</label>
              <d-form-input type="text" v-model="infoMerchantPartner.Name" readonly />
            </d-col>
            <d-col md="6"
              v-if="infoMerchantPartner.MerchantType.Code == '1' || infoMerchantPartner.MerchantType.Code == '5'"
              class="form-group">
              <label>CPF</label>
              <the-mask class="form-control" type="text" :mask="['###.###.###-##']"
                v-model="infoMerchantPartner.Identity" readonly />
            </d-col>
            <d-col v-else>
              <label>CNPJ</label>
              <the-mask class="form-control" type="text" :mask="['##.###.###/####-##']"
                v-model="infoMerchantPartner.Identity" readonly />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>{{ labelPartner }}</label>
              <d-select v-model="infoMerchantPartner.Partner.Id" :value="0" :disabled="true">
                <option :value="0" selected>Sem parceiro</option>
                <option v-for="partner in partners" v-bind:value="partner.Id" v-bind:key="partner.Id">
                  {{ partner.Name }}
                </option>
              </d-select>
            </d-col>
            <d-col md="6" class="form-group">
              <label>{{ labelPartnerUpdate }}</label>
              <d-select v-model="infoMerchantSolicitation.Partner.Id" :value="0" @change="changePartnerSolicitation">
                <option :value="0" selected>Sem parceiro</option>
                <option v-for="partner in partners" v-bind:value="partner.Id" v-bind:key="partner.Id">
                  {{ partner.Name }}
                </option>
              </d-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>{{ labelPartnerSDR }}</label>
              <d-select v-model="infoMerchantPartner.PartnerSDR.Id" :value="0" :disabled="true">
                <option :value="0" selected>Sem SDR</option>
                <option v-for="sdr in sdrs" v-bind:value="sdr.Id" v-bind:key="sdr.Id">
                  {{ sdr.Name }}
                </option>
              </d-select>
            </d-col>
            <d-col md="6" class="form-group">
              <label>{{ labelPartnerUpdateSDR }}</label>
              <d-select v-model="infoMerchantSolicitation.PartnerSDR.Id" :value="0" :disabled="!isAllowChooseSDR">
                <option :value="0" selected>Sem SDR</option>
                <option v-for="sdr in sdrs" v-bind:value="sdr.Id" v-bind:key="sdr.Id">
                  {{ sdr.Name }}
                </option>
              </d-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Motivo</label>
              <ValidationProvider rules="required|max:1000" v-slot="{ errors, invalid }">
                <b-form-textarea type="text" rows="4" :class="validatedUpdatePartner | showValidateError(invalid)"
                  v-model="infoMerchantSolicitation.Reason" />
                <div class="invalid-feedback d-block" v-if="validatedUpdatePartner">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="UpdatePartner()"
          :disabled="loadingUpdatePartner || loadingModalPartner">
          <template v-if="!loadingUpdatePartner">
            Solicitar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingUpdatePartner"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFormMerchantContract" title="Gerar contrato" size="lg" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <div>
        <h5>Instruções</h5>
        <hr />
        <label>- Informe os dados dos responsáveis apenas quando for diferente do informado na receita federal</label>
        <label class="mb-4">- IMPORTANTE: se estes campos forem informados, o nome do responsável que está cadastrado
          será
          desconsiderado</label>
        <h5>Contrato</h5>
        <hr />
        <ValidationObserver tag="form" ref="MerchantContractChargeForm">
          <d-form-row>

            <d-col md="6" class="form-group">
              <label>Tipo de conta</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMerchantContract.MerchantType.Id" :value="null"
                  @change="changeContractMerchantType"
                  :class="validatedMerchantContractCharge | showValidateError(invalid)">
                  <option :value="null" selected>Tipo de conta</option>
                  <option v-for="type in merchantTypes" v-bind:value="type.Id" v-bind:key="type.Id">
                    {{ type.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedMerchantContractCharge">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <d-col md="6" class="form-group" v-if="isShowPlans">
              <label>Plano</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMerchantContract.IdPlan" :value="null"
                  :class="validatedMerchantContractCharge | showValidateError(invalid)">
                  <option :value="null" selected>Selecione o plano</option>
                  <option :value="0">Sem mensalidade</option>

                  <option v-for="plan in plans" v-bind:key="plan.IdPlan" v-bind:value="plan.IdPlan">
                    {{ plan.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedMerchantContractCharge">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
        <ValidationObserver tag="form" ref="MerchantContractForm">
          <h5>Dados do Responsável</h5>
          <hr />
          <d-form-row>
            <d-col md="4" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required|min:10|name" v-slot="{ errors, invalid }">
                <d-form-input :class="validatedMerchantContract | showValidateError(invalid)" type="text"
                  v-model="activeMerchantResponsible.ResponsibleName" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantContract">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="4" class="form-group">
              <label>CPF</label>
              <ValidationProvider rules="required|min:11|identity" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedMerchantContract | showValidateError(invalid)"
                  type="text" :mask="['###.###.###-##']" v-model="activeMerchantResponsible.ResponsibleIdentity" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantContract">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="4" class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                <d-form-input type="text" :class="validatedMerchantContract | showValidateError(invalid)"
                  v-model="activeMerchantResponsible.ResponsibleEmail" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantContract">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <b-col>
              <b-button class="float-right" variant="success" size="sm" @click="AddMerchantResponsible($event)">
                Incluir Responsável</b-button>
            </b-col>
          </d-form-row>
        </ValidationObserver>
        <div v-if="
          infoMerchantContract.Responsibles != null &&
          infoMerchantContract.Responsibles != undefined &&
          infoMerchantContract.Responsibles.length > 0
        ">
          <br />
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>E-mail</th>
                <th class="actions"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(responsible, index) in infoMerchantContract.Responsibles" :key="index">
                <td>{{ responsible.ResponsibleName }}</td>
                <td>{{ responsible.ResponsibleIdentity | identity }}</td>
                <td>{{ responsible.ResponsibleEmail }}</td>
                <td>
                  <div class="text-right">
                    <b-button size="sm" variant="outline-secondary" @click="RemoveMerchantResponsible(index)">
                      <i class="fas fa-trash-alt" />
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <ValidationObserver tag="form" ref="MerchantContractDPOForm">
            <div>
              <h5>Dados do DPO</h5>
              <hr />
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Nome</label>
                  <ValidationProvider rules="required|min:10|name" v-slot="{ errors, invalid }">
                    <d-form-input :class="validatedMerchantContractDPO | showValidateError(invalid)" type="text"
                      v-model="infoMerchantContract.ResponsibleDPO.ResponsibleName" />
                    <div class="invalid-feedback d-block" v-if="validatedMerchantContractDPO">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <d-col md="6" class="form-group">
                  <label>Cargo</label>
                  <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                    <d-form-input class="form-control"
                      :class="validatedMerchantContractDPO | showValidateError(invalid)" type="text"
                      v-model="infoMerchantContract.ResponsibleDPO.ResponsibleOccupation" />
                    <div class="invalid-feedback d-block" v-if="validatedMerchantContractDPO">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Telefone</label>
                  <ValidationProvider rules="required|min:10" v-slot="{ errors, invalid }">
                    <the-mask class="form-control" :class="validatedMerchantContractDPO | showValidateError(invalid)"
                      type="tel" :mask="['(##) #####-####', '(##) ####-####']"
                      v-model="infoMerchantContract.ResponsibleDPO.ResponsiblePhone" />
                    <div class="invalid-feedback d-block" v-if="validatedMerchantContractDPO">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <d-col md="6" class="form-group">
                  <label>E-mail</label>
                  <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                    <d-form-input class="form-control"
                      :class="validatedMerchantContractDPO | showValidateError(invalid)" type="text"
                      v-model="infoMerchantContract.ResponsibleDPO.ResponsibleEmail" />
                    <div class="invalid-feedback d-block" v-if="validatedMerchantContractDPO">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
            </div>
          </ValidationObserver>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="GetMerchantContractValidate()" :disabled="loadingContract">
          <template v-if="!loadingContract">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingContract"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFormMerchantNegotiation" title="Negociação" size="lg" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <div>
        <div>
          <!-- <ValidationObserver tag="form" ref="MerchantNegotiatiosnForm"> -->
          <label>Escolha o método de pagamento</label>
          <d-form-row>
            <d-col md="6" class="form-group">
              <d-select v-model="infoMerchantNegotiation.IdPaymentMethod" :value="null">
                <option :value="null" selected>Selecione</option>
                <option v-for="paymentMethod in paymentMethods" v-bind:key="paymentMethod.Id"
                  v-bind:value="paymentMethod.Id">
                  {{ paymentMethod.Name }}
                </option>
              </d-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Data de Expedição</label>
              <date-field format="dd/MM/yyyy" v-model="infoMerchantNegotiation.DateNegotiation"></date-field>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Valor</label>
              <currency-input class="form-control" type="text" v-model="infoMerchantNegotiation.Amount" />
            </d-col>
            <d-col md="12" class="form-group">
              <b-col>
                <b-button class="float-right" variant="success" size="sm"
                  @click="AddMerchantNegotiation(infoMerchantNegotiation, $event)">Incluir
                </b-button>
              </b-col>
            </d-col>
            <hr />
          </d-form-row>

          <div class="card-body p-0 pb-3 text-center">
            <loader :is-loading="loadingNegotiation"></loader>
            <table class="table mb-12" v-if="!loadingNegotiation">
              <thead class="bg-s2p-gray-light">
                <tr>
                  <th scope="col-md-3" class="border-0">Método de Pagamento</th>
                  <th scope="col-md-3" class="border-0">Volume</th>
                  <th scope="col-md-3" class="border-0">Data</th>
                  <th scope="col-md-3" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(Negotiation, index) in MerchantNegotiations" :key="index">
                  <td>{{ Negotiation.PaymentMethod.Name }}</td>

                  <td>{{ Negotiation.Amount | currency }}</td>

                  <td>{{ Negotiation.DateNegotiation | date }}</td>

                  <td>
                    <a type="button" class="btn btn-secondary" href="#"
                      v-on:click.stop="ConfirmDeleteMerchantNegotiation(Negotiation, index)">
                      <i class="fas fa-trash-alt"></i> Remover
                    </a>
                  </td>
                </tr>
                <tr v-if="
                  MerchantNegotiations == undefined || MerchantNegotiations == null || MerchantNegotiations.length == 0
                ">
                  <td colspan="6">Sem Registros</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="SaveMerchantNegotiation()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)" :disabled="loadingAddUpdate || loadingModal">
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : "Salvar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="3" class="form-group">
          <input placeholder="Id" type="text" class="form-control" v-model="filter.Id" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="5" class="form-group">
          <input :placeholder="labelName" type="text" class="form-control" v-model="filter.Name"
            v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="4" class="form-group">
          <the-mask class="form-control" type="tel" :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity" v-bind:placeholder="labelIdentity" v-on:keyup.enter.native="Filter()" />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantType" :value="null">
            <option :value="null" selected>Tipo de conta</option>
            <option v-for="type in merchantTypes" v-bind:key="type.Code" v-bind:value="type.Code">
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsRemoved" :value="null">
            <option :value="false">Ativos</option>
            <option :value="true">Removidos</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdPartner" :value="null" :disabled="idPartner > 0">
            <option :value="null" selected>Parceiro</option>
            <option :value="0" selected>Sem parceiro</option>
            <option v-for="partner in partners" v-bind:key="partner.Id" v-bind:value="partner.Id">
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsTest" :value="null">
            <option :value="false">Clientes</option>
            <option :value="true">Clientes de teste</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsExpiredCommission" :value="null">
            <option :value="null">Status da comissão</option>
            <option :value="0">Comissão ativa</option>
            <option :value="1">Comissão inativa</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.AddressFilter.StateFilter.Initials" :value="null">
            <option :value="null" selected>Estado</option>
            <option v-for="state in statesFilter" v-bind:key="state.Initials" v-bind:value="state.Initials">
              {{ state.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.SourceDescription" :value="null">
            <option :value="null">Adicionado por</option>
            <option :value="3">Interno</option>
            <option :value="1">Site</option>
            <option :value="4">Partner</option>
            <option :value="2">Integração</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsAcceptedContract" :value="null">
            <option :value="2">Contrato assinado?</option>
            <option :value="1">Assinado</option>
            <option :value="0">Não assinado</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field placeholder="Data de Criação Inicial" v-model="filter.CreatedDateInitial"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field placeholder="Data de Criação Final" v-model="filter.CreatedDateEnd"></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar"
          @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          @click="ResetFilter()">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mReportProfit" title="Relatório de Faturamento" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Data de faturamento</label>
          <date-field v-model="profitDate" format="MMMM yyyy" minimumView="month" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="GetReportProfit()" :disabled="loadingReportProfit">
          <template v-if="!loadingReportProfit">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingReportProfit"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mReportState" title="Relatório de Faturamento Por Estado" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Data de faturamento</label>
          <date-field v-model="profitDate" format="MMMM yyyy" minimumView="month" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="GetReportState()" :disabled="loadingReportProfit">
          <template v-if="!loadingReportProfit">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingReportProfit"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mReportCity" title="Relatório de Faturamento Por Cidade" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Data de faturamento</label>
          <date-field v-model="profitDate" format="MMMM yyyy" minimumView="month" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="GetReportCity()" :disabled="loadingReportProfit">
          <template v-if="!loadingReportProfit">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingReportProfit"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="mSearchMerchant" title="Consulta Cliente" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">Procurar cliente</h5>
        <button class="close" @click="HideModalSearchMerchant()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <d-form-row v-if="!isListMerchant">
        <d-col md="6" class="form-group">
          <input placeholder="Nome" type="text" class="form-control" v-model="filterSearchMechant.Name"
            v-on:keyup.enter="FilterSearchMerchant()" />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask class="form-control" type="tel" :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filterSearchMechant.Identity" placeholder="CPF/CNPJ"
            v-on:keyup.enter.native="FilterSearchMerchant()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="Email" type="text" class="form-control" v-model="filterSearchMechant.Email"
            v-on:keyup.enter="FilterSearchMerchant()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="Id" type="number" class="form-control" v-model="filterSearchMechant.Id"
            v-on:keyup.enter="FilterSearchMerchant()" />
        </d-col>
      </d-form-row>
      <d-form-row v-if="isListMerchant">
        <div class="card-body p-0 pb-3 text-center">
          <loader :is-loading="loading"></loader>
          <table class="table mb-0" v-if="!loading">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0">Id</th>
                <th scope="col" class="border-0 text-left">Cliente</th>
                <th scope="col" class="border-0">Id do Marketplace</th>
                <th scope="col" class="border-0 text-left">Marketplace</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(merchant, index) in ListSearchMerchant" :key="index">
                <td>{{ merchant.Id }}</td>
                <td class="text-left td-with-subs">
                  <div>{{ merchant.Name | substring(50) }}</div>
                  <span>{{ merchant.Identity | identity }}</span>
                </td>
                <td v-if="merchant.IdMerchantRoot > 0">
                  {{ merchant.IdMerchantRoot }}
                </td>
                <td v-if="merchant.IdMerchantRoot == 0">
                  <i class="fas fa-minus"></i>
                </td>
                <td class="text-left td-with-subs" v-if="merchant.IdMerchantRoot > 0">
                  <div>{{ merchant.NameMerchantRoot | substring(50) }}</div>
                  <span>{{ merchant.IdentityMerchantRoot | identity }}</span>
                </td>
                <td v-if="merchant.IdMerchantRoot == 0">
                  <i class="fas fa-minus"></i>
                </td>
              </tr>
              <tr
                v-if="ListSearchMerchant == undefined || ListSearchMerchant == null || ListSearchMerchant.length == 0">
                <td colspan="5">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination class="float-right" v-model="paginationSearchMerchant.PageNumber"
                :total-rows="paginationSearchMerchant.TotalItems" :per-page="paginationSearchMerchant.RowsPerPage"
                aria-controls="my-table"></b-pagination>
              <div class="float-left">
                <d-select size="sm" v-model="paginationSearchMerchant.RowsPerPage">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </d-form-row>

      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar"
          v-if="!isListMerchant" @click="FilterSearchMerchant()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          v-if="!isListMerchant" @click="ResetFilterSearchMerchant()">
          <i class="fas fa-eraser"></i>
        </b-button>
        <b-button v-if="isListMerchant" size="sm" class="btn btn-secondary" @click="BackSearch()">
          <i class="fas fa-arrow-left"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="mFingerprint" title="Empresa com relação fingerprint/IP" centered
      :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <div class="col-7 text-center text-sm-left mb-0">
          <div class="input-group d-flex justify-content-end my-auto">
            <b-button variant="primary" class="input-group-text btn-sm ml-1 mt-3"
              :class="[filterText == 'fingerprint' ? 'active' : '']" v-b-tooltip.hover.bottom title="Fingerprint"
              @click="ClickFingerprint()">{{ "Fingerprint" }}</b-button>
            <b-button variant="primary" class="input-group-text btn-sm ml-1 mt-3"
              :class="[filterText == 'ip' ? 'active' : '']" v-b-tooltip.hover.bottom title="IP" @click="ClickIP()">{{
                "IP"
              }}</b-button>
          </div>
        </div>
        <div class="col-5">
          <button class="close" @click="HideModalFingerprintIP()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <d-form-row v-if="isListFingerprint && filterText == 'fingerprint'">
        <div class="card-body p-0 pb-3 text-center">
          <loader :is-loading="loadingFingerprint"></loader>
          <table class="table mb-0" v-if="!loadingFingerprint">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0 text-left">Empresa</th>
                <th scope="col" class="border-0">Bloqueado</th>
                <th scope="col" class="border-0">Fingerprint</th>
                <th scope="col" class="border-0">Marketplace</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in fingerprints" :key="index">
                <td class="text-left">
                  <div>{{ user.Merchant.Id }} - {{ user.Merchant.Name }}</div>
                </td>
                <td>
                  <i :class="[GetBlockedClass(user.IsBlocked)]"></i>
                </td>
                <td>
                  <div>{{ user.FingerprintCode }}</div>
                </td>
                <td v-if="user.IdMerchantRoot > 0">
                  <div>{{ user.IdMerchantRoot }} - {{ user.NameMerchantRoot }}</div>
                </td>
                <td v-else>
                  <i class="fas fa-minus"></i>
                </td>
              </tr>
              <tr v-if="fingerprints == undefined || fingerprints == null || fingerprints.length == 0">
                <td colspan="3">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination class="float-right" v-model="paginationFingerprint.PageNumber"
                :total-rows="paginationFingerprint.TotalItems" :per-page="paginationFingerprint.RowsPerPage"
                aria-controls="my-table"></b-pagination>
              <div class="float-left">
                <d-select size="sm" v-model="paginationFingerprint.RowsPerPage">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </d-form-row>
      <d-form-row v-if="isListIP && filterText == 'ip'">
        <div class="card-body p-0 pb-3 text-center">
          <loader :is-loading="loadingIP"></loader>
          <table class="table mb-0" v-if="!loadingIP">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0 text-left">Empresa</th>
                <th scope="col" class="border-0">Bloqueado</th>
                <th scope="col" class="border-0">IP</th>
                <th scope="col" class="border-0">Marketplace</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in ips" :key="index">
                <td class="text-left">
                  <div>{{ user.Merchant.Id }} - {{ user.Merchant.Name }}</div>
                </td>
                <td>
                  <i :class="[GetBlockedClass(user.IsBlocked)]"></i>
                </td>
                <td>
                  <div>{{ user.IPAddress }}</div>
                </td>
                <td v-if="user.IdMerchantRoot > 0">
                  <div>{{ user.IdMerchantRoot }} - {{ user.NameMerchantRoot }}</div>
                </td>
                <td v-else>
                  <i class="fas fa-minus"></i>
                </td>
              </tr>
              <tr v-if="ips == undefined || ips == null || ips.length == 0">
                <td colspan="3">Sem registros</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 border-top">
            <div class="pagination-nav">
              <b-pagination class="float-right" v-model="paginationIP.PageNumber" :total-rows="paginationIP.TotalItems"
                :per-page="paginationIP.RowsPerPage" aria-controls="my-table"></b-pagination>
              <div class="float-left">
                <d-select size="sm" v-model="paginationIP.RowsPerPage">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </d-select>
              </div>
            </div>
          </div>
        </div>
      </d-form-row>
      <template slot="modal-footer">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" hidden>
            <i class="fas fa-arrow-left"></i>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal id="mChangeEmail" title="Alterar e-mail" size="md" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <div>



        <ValidationObserver tag="form" ref="ChangeEmailForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                <div class="input-group">
                  <d-form-input :class="validatedChangeEmail | showValidateError(invalid)" type="email"
                    v-model="infoMerchantChangeEmail.Email" />
                </div>
                <div class="invalid-feedback d-block" v-if="validatedChangeEmail">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="12">
              <div class="form-group">
                <d-checkbox v-model="infoMerchantChangeEmail.IsChangeAdmUser">
                  Alterar o e-mail do usuário administrador?</d-checkbox>
              </div>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="ValidateUpdateEmail()" :disabled="loadingChangeEmail">
          <template v-if="!loadingChangeEmail">
            Alterar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingChangeEmail"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mValidateMerchant" title="Validar dados" size="md" centered :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <div>
        <ValidationObserver tag="form" ref="ValidateMerchantForm">
          <d-form-row>
            <d-col md="6">
              <div class="form-group">
                <label>Escolha o tipo de conta</label>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <d-select v-model="infoValidateMerchant.MerchantType.Code"
                    :class="validatedMerchant | showValidateError(invalid)">
                    <option :value="null" selected>Selecione</option>
                    <option v-for="type in merchantTypes" v-bind:value="type.Id" v-bind:key="type.Id">
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div class="invalid-feedback d-block" v-if="validatedMerchant">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
            <d-col md="6" class="form-group ckb">
              <d-checkbox v-model="infoValidateMerchant.IsTest">Utilizado para teste </d-checkbox>
            </d-col>
          </d-form-row>
          <d-form-row v-if="infoValidateMerchant.MerchantType.Code != 1 && infoValidateMerchant.MerchantType.Code != 5">
            <d-col md="12" class="form-group">
              <label>CNPJ</label>
              <ValidationProvider rules="required|min:14" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedMerchant | showValidateError(invalid)" type="text"
                  :mask="['##.###.###/####-##']" v-model="infoValidateMerchant.Identity" />
                <div class="invalid-feedback d-block" v-if="validatedMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12">
              <h5 v-if="infoValidateMerchant.MerchantType.Code != 1 && infoValidateMerchant.MerchantType.Code != 5">
                Dados do responsável
              </h5>
              <h5 v-else>Dados do cliente</h5>
              <hr />
            </d-col>
            <d-col v-if="infoValidateMerchant.MerchantType.Code != 1 && infoValidateMerchant.MerchantType.Code != 5"
              md="6" class="form-group">
              <label>CPF</label>
              <ValidationProvider rules="required|min:11|identity" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedMerchant | showValidateError(invalid)" type="text"
                  :mask="['###.###.###-##']" v-model="infoValidateMerchant.ResponsibleIdentity" />
                <div class="invalid-feedback d-block" v-if="validatedMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" v-else class="form-group">
              <label>CPF</label>
              <ValidationProvider rules="required|min:11|identity" v-slot="{ errors, invalid }">
                <the-mask class="form-control" :class="validatedMerchant | showValidateError(invalid)" type="text"
                  :mask="['###.###.###-##']" v-model="infoValidateMerchant.Identity"
                  @input="UpdateValidated('ResponsibleIdentity', $event)" />
                <div class="invalid-feedback d-block" v-if="validatedMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                <div class="input-group">
                  <d-form-input :class="validatedMerchant | showValidateError(invalid)" type="email"
                    v-model="infoValidateMerchant.Email" />
                </div>
                <div class="invalid-feedback d-block" v-if="validatedMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="ValidateMerchant()" :disabled="loadingValidateMerchant">
          <template v-if="!loadingValidateMerchant">
            Validar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingValidateMerchant"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <!-- Frequência Repasse -->
    <b-modal size="lg" id="mEditarFrequenciaRepasse" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
      <h5 class="col-10 no-gutters mb-0">Alterar Frequência do Repasse</h5>
      <button class="close" @click="HideModalFrequenciaRepasse()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      </template>
      <div v-if="loadingMerchant" class="d-flex justify-content-center py-5">
        <loader :is-loading="true"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="EditarFrequenciaRepasseForm">
          <div v-if="!infoMerchant.BankData.Bank.Code">
            <div>
              <p>Dados bancários não encontrados para o repasse.</p>
            </div>
          </div>
          <div v-else>
            <d-form-row>
              <d-col md="6" class="form-group">
                <label>Código</label>
                <d-form-input type="text" v-model="infoMerchant.BankData.Bank.Code" readonly />
              </d-col>
              <d-col md="6" class="form-group float-right">
                <label>Banco</label>
                <d-form-input type="text" v-model="infoMerchant.BankData.Bank.Name" readonly />
              </d-col>
            </d-form-row>
              <d-form-row>
                <d-col md="3" class="form-group">
                  <label>Agência</label>
                  <div class="input-group">
                    <d-form-input type="text" v-model="infoMerchant.BankData.BankAgency" readonly />
                  </div>
                </d-col>
              <d-col md="3" class="form-group">
                <label>Dígito</label>
                <div class="input-group">
                  <d-form-input type="text" v-model="infoMerchant.BankData.BankAgencyDigit" readonly />
                </div>
              </d-col>
              <d-col md="3" class="form-group">
                <label>Conta</label>
                <div class="input-group">
                  <d-form-input type="text" v-model="infoMerchant.BankData.BankAccount" readonly />
                </div>
              </d-col>
              <d-col md="3" class="form-group">
                <label>Dígito</label>
                <div class="input-group">
                  <d-form-input type="text" v-model="infoMerchant.BankData.BankAccountDigit" readonly />
                </div>
              </d-col>
            </d-form-row>
            <d-form-row>
              <d-col md="6" class="form-group">
                <label>Tipo de Conta</label>
                <div class="input-group">
                  <d-form-input type="text" v-model="infoMerchant.BankData.AccountType.Name" readonly />
                </div>
              </d-col>
            </d-form-row>
          </div>
          
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Frequência do Repasse</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <select v-if="!loadingEditarFrequenciaRepasse" v-model="infoMerchant.MerchantPaymentDate.PlanFrequence.Id" class="custom-select">
                  <option :value=7>Diário</option>
                  <option :value=6>Semanal</option>
                  <option :value=1>Mensal</option>
                </select>
              </ValidationProvider>
            </d-col>
              <d-col md="6" class="form-group float-right" v-if="infoMerchant.MerchantPaymentDate.PlanFrequence.Id === 1">
                <label>Dia do Pagamento</label>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <d-form-input class="form-control" :class="validatedFrequenciaRepasse | showValidateError(invalid)" type="number" :max="infoMerchant.MerchantPaymentDate.PlanFrequence.Id === 6 ? 6 : null" v-model.number="infoMerchant.MerchantPaymentDate.PaymentDay"/>                      
                  <div class="invalid-feedback d-block" v-if="validatedFrequenciaRepasse">
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <d-col md="6" class="form-group float-right" v-if="infoMerchant.MerchantPaymentDate.PlanFrequence.Id === 6">
                <label>Dia do Pagamento</label>
                  <div v-if="infoMerchant.MerchantPaymentDate.PlanFrequence.Id === 6">
                    <ValidationProvider v-if="infoMerchant.MerchantPaymentDate.PlanFrequence.Id === 6" name="Dia do pagamento" rules="required" v-slot="{ errors, validated }">
                      <select v-model="infoMerchant.MerchantPaymentDate.PaymentDay" :class="{ 'is-invalid': validated && errors.length }" class="custom-select">
                        <option :value="null" disabled hidden>Selecione o dia da semana</option>
                        <option v-for="dia in diasSemanaOptions" :key="dia.id" :value="dia.id">
                          {{ dia.label }}
                        </option>
                      </select>
                      <div v-if="validated && errors.length" class="invalid-feedback d-block">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </div>
              </d-col>
            </d-form-row>
        </ValidationObserver>
      </div>

        <template slot="modal-footer">
        <b-button-group>
          <b-button type="button" class="btn btn-success" v-on:click="EditarFrequenciaRepasse()" :disabled="loadingEditarFrequenciaRepasse || loadingMerchant">
            <template v-if="loadingEditarFrequenciaRepasse || loadingMerchant">
              <loader :small="true" :isLoading="loadingEditarFrequenciaRepasse || loadingMerchant"></loader>
            </template>
            <template v-else> Salvar </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <!-- Classificação -->
    <b-modal size="md" id="mClassificacao" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">Classificação do Cliente</h5>
        <button class="close" @click="HideModalClassificacao()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <div v-if="loadingClassificacao" class="d-flex justify-content-center py-5">
        <loader :is-loading="true"></loader>
      </div>
      <div v-else>
        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Nicho</label>
            <VueTypeaheadBootstrap
              v-model="nichoSearch"
              :data="nichos"
              :serializer="item => item.Nome"
              :minMatchingChars="0"
              :showOnFocus="true"
              :maxMatches="999"
              placeholder="Pesquisar nicho..."
              @hit="classificacao.Nicho = { Id: $event.Id, Nome: $event.Nome }"
            />
            <small v-if="nichoSearch && !nichoExisteNaLista" class="text-muted">
              Nicho não encontrado.
              <a href="#" @click.prevent="CadastrarNicho()">Criar "{{ nichoSearch }}"</a>
            </small>
          </d-col>
          <d-col md="12" class="form-group">
            <label>Segmento</label>
            <VueTypeaheadBootstrap
              v-model="segmentoSearch"
              :data="segmentos"
              :serializer="item => item.Nome"
              :minMatchingChars="0"
              :showOnFocus="true"
              :maxMatches="999"
              placeholder="Pesquisar segmento..."
              @hit="classificacao.Segmento = { Id: $event.Id, Nome: $event.Nome }"
            />
            <small v-if="segmentoSearch && !segmentoExisteNaLista" class="text-muted">
              Segmento não encontrado.
              <a href="#" @click.prevent="CadastrarSegmento()">Criar "{{ segmentoSearch }}"</a>
            </small>
          </d-col>
        </d-form-row>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button type="button" class="btn btn-success"
            v-on:click="SalvarClassificacao()"
            :disabled="loadingClassificacao || classificacao.Nicho.Id === 0 || classificacao.Segmento.Id === 0">
            <template v-if="loadingClassificacao">
              <loader :small="true" :isLoading="loadingClassificacao"></loader>
            </template>
            <template v-else>Salvar</template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <!-- Limite -->
    <b-modal size="lg" id="mFormMerchantLimits" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">Alterar limite</h5>
        <button class="close" @click="HideModalMerchantLimits()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingMerchantLimits"></loader>

      <!-- Dados: limites -->
      <div v-if="!loadingMerchantLimits">
        <ValidationObserver tag="form" ref="MerchantLimitsForm">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Percentual máximo de antecipação</label>
              <ValidationProvider rules="required|min_value:0|max_value:100" v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantLimits | showValidateError(invalid)"
                  v-model="infoMerchantLimits.AntecipacaoPercentualMaximo" type="percentage" :maxDecimalPlaces="1" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantLimits">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Percentual máximo de Disputa</label>
              <ValidationProvider rules="required|min_value:0|max_value:100" v-slot="{ errors, invalid }">
                <decimal-field class="form-control" :class="validatedMerchantLimits | showValidateError(invalid)"
                  v-model="infoMerchantLimits.DisputaPercentualMaximo" type="percentage" :maxDecimalPlaces="1" />
                <div class="invalid-feedback d-block" v-if="validatedMerchantLimits">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button type="button" class="btn btn-success" v-on:click="UpdateMerchantLimits()"
            :disabled="loadingCreateUpdate">
            <template v-if="!loadingCreateUpdate"> Salvar </template>
            <template v-else>
              <loader :small="true" :isLoading="loadingCreateUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>
    <!--Método de pagamento Marketplace -> MerchantPaymenthMethod.vue -->
    <MerchantPaymenthMethod :idMerchant="idMerchant" :idMerchantRoot="idMerchantRoot"
      :showModal.sync="modalPaymentMethod" />

    <!-- <ticket-register :OnClose="OnCloseTicketModal" /> -->
  </div>
</template>

<script>
import dateField from "../common/date-field";
import decimalField from "../common/decimal-field.vue";
import ticketRegister from "../modals/ticketRegister.vue";
import { hasValue } from "../../utils/functions.js";
import { mapGetters } from "vuex";

import MerchantPaymentMethod from "../sub-components/Merchants/MerchantPaymentMethod.vue";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

export default {
  name: "merchants",
  components: {
    dateField,
    decimalField,
    ticketRegister,
    MerchantPaymenthMethod: MerchantPaymentMethod,
    VueTypeaheadBootstrap,
  },
  data: function () {
    return {
      profitDate: this.$options.filters.date(this.$options.filters.addMonth(new Date(), -1), "YYYY-MM-DD"),
      CreatedDateInitial: null,
      CreatedDateEnd: null,
      firstLoad: true,
      countFilter: 1,
      idMerchantRoot: 0,
      idPartner: 0,
      idTicket: 0,
      filterText: "fingerprint",
      arraySteps: [],
      merchantBloquear: {
        Id: 0,
        Name: null,
        Identity: null,
        Observacao: null,
        IsBlocked: false,
        IsRemoved: false,
      },
      merchantRemover: {
        Id: 0,
        Name: null,
        Identity: null,
        Observacao: null,
        IsBlocked: false,
        IsRemoved: false,
      },
      motivoRemocao: null,
      filter: {
        Id: null,
        Name: null,
        Identity: null,
        CodeMerchantType: null,
        IdPartner: this.idPartner > 0 ? this.idPartner : null,
        IsRemoved: false,
        IsTest: false,
        IsMerchantRoot: true,
        IsExpiredCommission: null,
        SourceDescription: null,
        IsAcceptedContract: this.listPendingAcceptedContract ? 0 : 2,
        AddressFilter: {
          StateFilter: {
            Initials: null,
          },
        },
      },
      filterRoot: {},
      isMerchantRoot: true,
      isMerchantRootReport: true,
      isRemoved: false,
      isListMerchant: false,
      isListFingerprint: false,
      isListIP: false,
      isSearchZipCode: false,
      isMarketplace: false,
      isEdit: false,
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      labelPartner: "Parceiro anterior",
      labelPartnerUpdate: "Parceiro",
      labelPartnerSDR: "SDR Parceiro anterior",
      labelPartnerUpdateSDR: "SDR Parceiro",
      listPendingAcceptedContract: false,
      loading: false,
      loadingCreateUpdate: false,
      loadingDownload: false,
      loadingFingerprint: false,
      loadingIP: false,
      loadingMerchant: false,
      loadingReport: false,
      loadingReportProfit: false,
      loadingResendEmail: false,
      loadingResendTechEmail: false,
      loadingContract: false,
      loadingChangeEmail: false,
      loadingValidateMerchant: false,
      loadingModalPartner: false,
      loadingUpdatePartner: false,
      loadingMerchantLimits: false,
      loadingAddUpdate: false,
      loadingNegotiation: false,
      loadingList: false,
      loadingUpdateBlocked: false,
      loadingUpdateRemove: false,
      loadingEditarFrequenciaRepasse: false,
      loadingClassificacao: false,
      nichos: [],
      segmentos: [],
      classificacao: { IdMerchant: 0, Nicho: { Id: 0 }, Segmento: { Id: 0 } },
      nichoSearch: "",
      segmentoSearch: "",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      paginationSearchMerchant: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      paginationFingerprint: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      paginationIP: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      idMerchant: 0,
      merchants: [],
      fingerprints: [],
      FingerprintCode: null,
      IpAddress: null,
      MerchantNegotiationsBack: [],
      MerchantNegotiationsFront: [],
      negotiation_list: [],
      negotiation: [],
      pOpened: null,
      infoMerchant: {
        Name: null,
        Identity: null,
        IsTest: false,
        IsMEI: false,
        IsSendWelcomeEmail: true,
        IsChangeAdmUser: false,
        MerchantType: {
          Code: null,
        },
        BillingType: {
          Code: null,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
        SDRID: 0,
        TypeReceipt: {
          Id: 0,
        },
        AntifraudeCategoria: {
          Id: null
        },
        AdditionalInformation: {
          GrossBillingAmount: 0,
          IsApi: false,
          IsInterface: false,
          IsMarketplace: false,
          IsOperation: false,
          IsOtherSoftware: false,
        },
        Address: {
          Complement: "",
          District: null,
          Number: "",
          Street: "",
          ZipCode: "",
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
        BankData: {
          BankAgency: null,
          BankAgencyDigit: null,
          BankAccount: null,
          BankAccountDigit: null,
          Bank: {
            Code: null,
            Name: null,
          },
          AccountType: {
            Name: null,
          },
        },
        Configuration: {
          MerchantPaymentMethod: [],
        },
        MerchantPaymentDate: {
          PlanFrequence: {
            Name: null,
          },
        },
        UserInternal: null,
        IsAuthorizedAPI: true,
        IsEnabled3DS: false,
        ProviderPrimary: {
          Id: 0,
          Code: null,
          Name: null,
        },
        MaquinaMensalidade: {
          Id: 0,
          ValorAluguel: 0,
          ValorTpvParaIsencao: 0,
          TpvCompartilhado: false,
          Ativo: false
        }
      },

      infoMerchantSplitTax: [],

      filterSearchMechant: {
        Name: null,
        Identity: null,
        Email: null,
        Id: null,
      },
      ListSearchMerchant: [],
      infoMerchantPartner: {
        Id: null,
        Name: null,
        Identity: null,
        SourceDescription: null,
        CreatedDate: null,
        MerchantType: {
          Code: null,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
      },
      infoMerchantSolicitation: {
        Merchant: {
          Id: 0,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
        Reason: null,
      },
      activeMerchantResponsible: {
        ResponsibleName: null,
        ResponsibleIdentity: null,
        ResponsibleEmail: null,
        CodeMerchantType: null,
        IdPlan: null,
      },
      infoMerchantNegotiation: this.DefaultInfoMerchantNegotiation(),
      infoMerchantContract: {
        IdMerchant: 0,
        MerchantType: {
          Id: 0
        },
        ResponsibleDPO: {
          ResponsibleName: null,
          ResponsibleOccupation: null,
          ResponsiblePhone: null,
          ResponsibleEmail: null,
        },
        Responsibles: [],
        IdPlan: null
      },
      infoMerchantChangeEmail: {
        Id: 0,
        Email: null,
        IsChangeAdmUser: false,
        ResponsibleIdentity: null,
      },
      infoValidateMerchant: {
        MerchantType: {
          Code: 2,
        },
        Email: null,
        ResponsibleIdentity: null,
        Identity: null,
        IsTest: false,
      },
      infoMerchantLimits: {
        AntecipacaoPercentualMaximo: 0,
        DisputaPercentualMaximo: 0
      },
      isValidated: false,
      isSeeing: false,
      isAllowChooseSDR: false,
      isShowPlans: true,
      modalTitle: "Novo cliente",
      mSteps: [
        "compate", //0
        "owner", //1
        "contact", //2
        "taxes", //3
        "information", //4
        "docs", //5
        "checkList", //6
        "tickets", //7
        "cnae", //8
        "bank", //9
        "history", //10
        "limits", //11
        "alerts", //12
        "Maquininhas", //13
        "confirm" //14
      ],
      listMerchantAntifraudeCategory: [],
      billingTypes: [],
      cities: [],
      configurationTaxes: [],
      countries: [],
      currentTaxes: [],
      mCurrentStep: 0,
      merchantCheckListDates: [],
      merchantCheckLists: [],
      merchantCnaes: [],
      merchantClassificacao: null,
      merchantDocs: [],
      merchantTickets: [],
      merchantTypes: [],
      plans: [],
      merchantsPreviewHistory: [],
      listaAlertasMerchant: [],
      gateways: [],
      partners: [],
      sdrs: [],
      previousPageinfo: [],
      redirectOpen: false,
      states: [],
      tableKey: 0,
      taxPaymentMethod: null,
      ticketsTableKey: 0,
      typesReceipt: [],
      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedTaxForm: false,
      validatedTechStep: false,
      validatedChangeEmail: false,
      validatedMerchant: false,
      validatedUpdatePartner: false,
      validatedMerchantContract: false,
      validatedMerchantContractDPO: false,
      validatedMerchantContractCharge: false,
      validatedMerchantLimits: false,
      validatedMerchantMaquininhas: false,
      validatedBloquearForm: false,
      validatedRemoverForm: false,
      validatedFrequenciaRepasse: false,
      estadoAnteriorFrequenciaRepasse: null,
      loadingModal: false,
      eventValidate: null,
      activeTaxConfig: {
        PaymentMethod: {
          Code: null,
          Name: null,
        },
        TaxType: {
          Code: 1,
        },
        Amount: null,
        EndInstallment: null,
        InitialInstallment: null,
        IsEnabled: true,
      },
      infoTax: {
        InitialInstallment: null,
        EndInstallment: null,
        Amount: null,
        TaxType: {
          Code: null,
        },
        PaymentIsEnabled: null,
      },
      selected_payment: null,
      paymentMethods: [],
      statesFilter: [],
      window: {
        width: 0,
        height: 0,
      },
      modalPaymentMethod: false,
      alertaSelecionado: {
        Id: null,
        DataCriacao: null,
        DataResolucao: null,
        Descricao: null,
        Merchant: {
          Id: null,
          Name: null,
        },
        UsuarioResolucao: {
          Id: null,
          Nome: null,
        },
      },
      validatedAtualizarForm: false,
      merchantAtualizar: {
        Id: null,
        Name: "",
        Identity: "",
        Observacao: "",
      },
    };
  },
  computed: {
    nichoExisteNaLista() {
      return this.nichos.some(n => n.Nome.toLowerCase() === this.nichoSearch.toLowerCase());
    },
    segmentoExisteNaLista() {
      return this.segmentos.some(s => s.Nome.toLowerCase() === this.segmentoSearch.toLowerCase());
    },
    MerchantNegotiations() {
      return [...this.MerchantNegotiationsBack, ...this.MerchantNegotiationsFront];
    },
    Country() {
      return this.infoMerchant.Address.Country.Name;
    },
    State() {
      return this.infoMerchant.Address.State.Initials;
    },
    ResponsibleIdentity() {
      if (this.infoMerchant.ResponsibleIdentity)
        return this.$options.filters.identity(this.infoMerchant.ResponsibleIdentity);
      else return "";
    },
    ResponsibleTechIdentity() {
      if (this.infoMerchant.TechIdentity) return this.$options.filters.identity(this.infoMerchant.TechIdentity);
      else return "";
    },
    MerchantTypeName() {
      const currentMTcode = this.infoMerchant.MerchantType.Code;

      if (this.merchantTypes.length > 0 && currentMTcode != null) {
        let merchantType = this.merchantTypes.find(function (elm) {
          return elm.Code == currentMTcode;
        });
        return merchantType.Name || "";
      }
      return "";
    },
    MerchantTypeCode: {
      get() {
        return this.infoMerchant.MerchantType.Code;
      },
      set(value) {
        if (value != null) {
          if (this.pOpened != null && !this.isSeeing && value != this.MerchantTypeCode) {
            this.ChangeMerchantType(value);
          } else {
            if (this.pOpened == null) {
              this.ChangeMerchantType(value);
              this.UpdateMerchantMethodsAndTaxes(value);
            }
          }
        } else {
          this.$makeToast("Não é possivel deixar sem opção definida", "info", "");
        }
      },
    },
    HasMerchantCnaes() {
      return this.merchantCnaes != null && this.merchantCnaes.length > 0;
    },
    HasPerfilAtuacao() {
      return this.HasMerchantCnaes || this.isSeeing;
    },
    HasMerchantBankData() {
      return (
        this.infoMerchant.BankData != null &&
        this.infoMerchant.BankData !== undefined &&
        (this.infoMerchant.BankData.BankAccount != "" || this.infoMerchant.BankData.BankAgency != "")
      );
    },
    HasMerchantPreview() {
      return this.merchantsPreviewHistory != null && this.merchantsPreviewHistory.length > 0;
    },
    HasMerchantDocs() {
      return this.merchantDocs != null && this.merchantDocs.length > 0;
    },
    HasMerchantCheckList() {
      return this.isSeeing && this.merchantCheckLists != null && this.merchantCheckLists.length > 0;
    },
    HasMerchantTickets() {
      return this.isSeeing && this.merchantTickets != null && this.merchantTickets.length > 0;
    },
    diasSemanaOptions() {
    return [
      { id: 2, label: 'Segunda-feira' },
      { id: 3, label: 'Terça-feira' },
      { id: 4, label: 'Quarta-feira' },
      { id: 5, label: 'Quinta-feira' },
      { id: 6, label: 'Sexta-feira' }
    ];
  }
    // ...mapGetters(["TicketSourceList", "TicketStatusList"]),
  },
  watch: {
    nichoSearch(val) {
      if (!val || val !== (this.classificacao.Nicho && this.classificacao.Nicho.Nome)) {
        this.classificacao.Nicho = { Id: 0 };
      }
    },
    segmentoSearch(val) {
      if (!val || val !== (this.classificacao.Segmento && this.classificacao.Segmento.Nome)) {
        this.classificacao.Segmento = { Id: 0 };
      }
    },
    modalPaymentMethod() {
      this.modalPaymentMethod;
    },
    "pagination.PageNumber": function () {
      this.ListMerchant();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchant();
    },
    "paginationSearchMerchant.PageNumber": function () {
      this.SearchMerchant();
    },
    "paginationSearchMerchant.RowsPerPage": function () {
      this.SearchMerchant();
    },
    "paginationFingerprint.PageNumber": function () {
      this.ListFingerprint(this.idMerchant);
    },
    "paginationFingerprint.RowsPerPage": function () {
      this.ListFingerprint(this.idMerchant);
    },
    "paginationIP.PageNumber": function () {
      this.ListIP(this.idMerchant);
    },
    "paginationIP.RowsPerPage": function () {
      this.ListIP(this.idMerchant);
    },
    "infoMerchant.AdditionalInformation.IsOperation": function (nv) {
      if (!nv) {
        this.infoMerchant.AdditionalInformation.GrossBillingAmount = 0;
      }
    },
    "infoMerchant.MerchantType.Code": function (nv) {
      // Update the list of taxes according to current merchant type.
      let taxes = this.configurationTaxes.filter(function (confTax) {
        return confTax.MerchantType.Code == nv;
      });

      this.currentTaxes = taxes;
    },
    selected_payment: function (nv) {
      // Find the current taxes for the payment method selected.
      let taxElm = this.currentTaxes.find(function (config) {
        return config.PaymentMethod.Code == nv;
      });

      if (taxElm != null) {
        this.activeTaxConfig = JSON.parse(JSON.stringify(taxElm));
        this.activeTaxConfig.IsEnabled = true;
      } else {
        let payment = this.paymentMethods.find(function (pymt) {
          return pymt.Code == nv;
        });
        if (payment != null) {
          delete payment.Id;
          this.activeTaxConfig = JSON.parse(
            JSON.stringify({
              PaymentMethod: payment,
              TaxType: {
                Code: 1,
                Name: null,
              },
              Amount: 0.0,
              InitialInstallment: 0,
              EndInstallment: 0,
              IsEnabled: true,
            })
          );
        } else {
          this.activeTaxConfig.PaymentMethod.Code = null;
        }
      }
    },
    State(selected, old) {
      if (selected != null) {
        this.$store.dispatch("ListCity", { stateInitials: selected }).then((response) => {
          this.cities = response;
        });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchant.Address.City.Name = null;
        }
      } else {
        this.cities = [];
        this.infoMerchant.Address.City.Name = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListState(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchant.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.infoMerchant.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    'infoMerchant.MerchantPaymentDate.PlanFrequence.Id': {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal) return;

        if (!this.estadoAnteriorFrequenciaRepasse) {
          this.estadoAnteriorFrequenciaRepasse = {
            planFrequenceId: newVal,
            planFrequenceName: this.infoMerchant.MerchantPaymentDate.PlanFrequence.Name,
            paymentDay: this.infoMerchant.MerchantPaymentDate.PaymentDay
          };
        }
        if (oldVal) {
          if (oldVal !== 6 && newVal === 6) {
            this.infoMerchant.MerchantPaymentDate.PaymentDay = null;
          }
        }
      }
    }
  },
  beforeMount() {
    let params = this.$route.query;

    if (params != null) {
      if (params.mId) {
        this.idMerchant = parseInt(params.mId, 10);
        this.redirectOpen = true;
      }
      if (params.previous) {
        this.previousPageinfo = params.previous;
      }
    }
  },
  created() {
    let params = this.$route.query;
    if (params != null) {
      if (params.idPartner) this.idPartner = parseInt(params.idPartner, 10);
    }
    if (this.idPartner > 0) this.filter.IdPartner = this.idPartner;

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.redirectOpen) {
      this.isSeeing = true;
      this.modalTitle = "Detalhes do cliente";
      this.GetMerchant(this.idMerchant);
      this.$bvModal.show("mFormMerchant");
      this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
        if (modalId === "mFormMerchant") this.previousPage();
      });
    } else {
      this.CheckFiltersOnStore();
      this.ResetFilter();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.ListCountry();
    this.ListConfigurationTax();
    this.ListMerchantType();
    this.ListBillingType();
    this.ListPaymentMethods();
    this.ListPartner();
    this.ListSDRs();
    this.ListMerchantAntifraudeCategory();
    this.listPlans();
    this.ListTypeReceipt();
    this.ListStateFilter();
    this.ListGateways();
    if (this.idPartner > 0) this.filter.IdPartner = this.idPartner;
    this.ResetFilter();
    if (this.$route.query.listPendingAcceptedContract == "true") {
      this.listPendingAcceptedContract = true;
      this.filter.IsAcceptedContract = 0;
    }

    if (this.$route.query !== undefined && this.$route.query.open == true) this.$bvModal.show("mValidateMerchant");
  },
  methods: {
    IsAuthorizedShow: function () {
      return (
        this.$isAuthorize("Merchant", "Get") ||
        (this.$isAuthorize("Merchant", "Update") && this.$isAuthorize("Merchant", "Get")) ||
        this.$isAuthorize("Merchant", "UpdateRemoved") ||
        this.$isAuthorize("Merchant", "UpdateBlocked") ||
        this.$isAuthorize("Merchant", "UpdatePartner") ||
        this.$isAuthorize("Merchant", "UpdateEmail") ||
        this.$isAuthorize("Merchant", "Clear") ||
        this.$isAuthorize("Merchant", "GetContract") ||
        this.$isAuthorize("MerchantPlan", "List") ||
        this.$isAuthorize("Merchant", "ListMerchantHistory") ||
        this.$isAuthorize("Transaction", "List") ||
        this.$isAuthorize("Ticket", "Add") ||
        this.$isAuthorize("MerchantSolicitation", "Add") ||
        this.$isAuthorize("MerchantDoc", "List") ||
        this.$isAuthorize("MerchantNote", "List") ||
        this.$isAuthorize("MerchantUser", "List") ||
        this.$isAuthorize("Training", "List") ||
        this.$isAuthorize("Fingerprint", "List") ||
        this.$isAuthorize("CheckingAccount", "List") ||
        this.$isAuthorize("MerchantLimits", "Update") ||
        this.$isAuthorize("Merchant", "Clear") ||
        this.$isAuthorize("Merchant", "ListMerchantHistory") ||
        this.$isAuthorize("Transaction", "List") ||
        this.$isAuthorize("Ticket", "Add") ||
        this.$isAuthorize("MerchantSolicitation", "Add") ||
        this.$isAuthorize("Merchant", "GetContract") ||
        this.$isAuthorize("MerchantDoc", "List") ||
        this.$isAuthorize("MerchantNote", "List") ||
        this.$isAuthorize("MerchantUser", "List") ||
        this.$isAuthorize("Training", "List") ||
        this.$isAuthorize("Fingerprint", "List") ||
        this.$isAuthorize("CheckingAccount", "List") ||
        this.$isAuthorize("MerchantLimits", "Update")
      );
    },
    ValidateFieldsTechResponsible: function () {
      if (this.infoMerchant.TechName || this.infoMerchant.TechIdentity || this.infoMerchant.TechEmail || this.infoMerchant.TechPhone) {
        return true;
      }
      else {
        this.validatedTechStep = false;
        return false;
      }
    },
    BackSearch: function () {
      this.ListSearchMerchant = [];
      this.isListMerchant = false;
    },
    ResetFilterSearchMerchant: function () {
      this.filterSearchMechant = {
        Name: null,
        Identity: null,
        Email: null,
        Id: null,
      };
      this.ListSearchMerchant = [];
    },
    FilterSearchMerchant: function () {
      this.SearchMerchant();
    },
    SearchMerchant: function () {
      let data = {
        ...this.paginationSearchMerchant,
        "Object.Identity": this.filterSearchMechant.Identity,
        "Object.Name": this.filterSearchMechant.Name,
        "Object.Email": this.filterSearchMechant.Email,
        "Object.Id": this.filterSearchMechant.Id,
      };

      this.$store
        .dispatch("ListMerchantSearch", { params: data })
        .then((response) => {
          this.ListSearchMerchant = response.Objects;
          this.paginationSearchMerchant.TotalItems = response.TotalItems;
          this.isListMerchant = true;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os clientes", error);
        })
        .finally(() => (this.loading = false));
    },
    ListMerchantAntifraudeCategory: function () {
      this.$store
        .dispatch("ListMerchantAntifraudeCategory")
        .then((response) => {
          this.listMerchantAntifraudeCategory = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os as categorias de antifraude", error);
        });

    },
    OpenModalSearchMerchant: function () {
      this.filterSearchMechant = {
        Name: null,
        Identity: null,
        Email: null,
        Id: null,
      };
      this.ListSearchMerchant = [];

      this.$bvModal.show("mSearchMerchant");
    },
    IsEmissionInProd: function (isSandBoxProd, isPaidProd) {
      return isSandBoxProd == false && isPaidProd == false;
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    OpenModalAlerta(alertaMerchant) {
      if (alertaMerchant != null && alertaMerchant.Id > 0) {
        this.alertaSelecionado = null;
        this.$bvModal.show("mVisualizarAlerta");
        this.alertaSelecionado = JSON.parse(JSON.stringify(alertaMerchant));
      }
    },
    HideModalSearchMerchant: function () {
      this.$bvModal.hide("mSearchMerchant");
      this.filterSearchMechant = {
        Name: null,
        Identity: null,
        Email: null,
        Id: null,
      };
      this.isListMerchant = false;
      this.ListSearchMerchant = [];
    },
    HideModalFrequenciaRepasse: function () {
      this.$bvModal.hide("mEditarFrequenciaRepasse");
      this.ResetInfoMerchantBankData();
    },
    HideModalClassificacao: function () {
      this.$bvModal.hide("mClassificacao");
    },
    async OpenModalClassificacao(e, idMerchant) {
      e.preventDefault();
      this.loadingClassificacao = true;
      this.classificacao = { IdMerchant: idMerchant, Nicho: { Id: 0 }, Segmento: { Id: 0 } };
      this.nichoSearch = "";
      this.segmentoSearch = "";
      this.$bvModal.show("mClassificacao");

      try {
        const [nichos, segmentos, atual] = await Promise.all([
          this.$store.dispatch("ListNichos"),
          this.$store.dispatch("ListSegmentos"),
          this.$store.dispatch("GetMerchantClassificacao", idMerchant).catch(() => null),
        ]);

        this.nichos = nichos || [];
        this.segmentos = segmentos || [];

        if (atual && atual.Nicho) {
          this.classificacao.Nicho = { Id: atual.Nicho.Id, Nome: atual.Nicho.Nome };
          this.nichoSearch = atual.Nicho.Nome;
        }
        if (atual && atual.Segmento) {
          this.classificacao.Segmento = { Id: atual.Segmento.Id, Nome: atual.Segmento.Nome };
          this.segmentoSearch = atual.Segmento.Nome;
        }
      } catch (error) {
        this.$makeToast(undefined, "danger", "Erro ao carregar classificação", error);
      } finally {
        this.loadingClassificacao = false;
      }
    },
    SalvarClassificacao() {
      this.loadingClassificacao = true;
      this.$store
        .dispatch("SalvarMerchantClassificacao", this.classificacao)
        .then(() => {
          this.$makeToast("Classificação salva com sucesso", "success", "Sucesso");
          this.$bvModal.hide("mClassificacao");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao salvar classificação", error);
        })
        .finally(() => {
          this.loadingClassificacao = false;
        });
    },
    async CadastrarNicho() {
      const nome = this.nichoSearch.trim();
      if (!nome) return;
      this.loadingClassificacao = true;
      try {
        const novo = await this.$store.dispatch("CadastrarNicho", nome);
        this.nichos = [...this.nichos, novo].sort((a, b) => a.Nome.localeCompare(b.Nome));
        this.classificacao.Nicho = { Id: novo.Id, Nome: novo.Nome };
        this.nichoSearch = novo.Nome;
        this.$makeToast(`Nicho "${novo.Nome}" cadastrado`, "success", "Sucesso");
      } catch (error) {
        this.$makeToast(undefined, "danger", "Erro ao cadastrar nicho", error);
      } finally {
        this.loadingClassificacao = false;
      }
    },
    async CadastrarSegmento() {
      const nome = this.segmentoSearch.trim();
      if (!nome) return;
      this.loadingClassificacao = true;
      try {
        const novo = await this.$store.dispatch("CadastrarSegmento", nome);
        this.segmentos = [...this.segmentos, novo].sort((a, b) => a.Nome.localeCompare(b.Nome));
        this.classificacao.Segmento = { Id: novo.Id, Nome: novo.Nome };
        this.segmentoSearch = novo.Nome;
        this.$makeToast(`Segmento "${novo.Nome}" cadastrado`, "success", "Sucesso");
      } catch (error) {
        this.$makeToast(undefined, "danger", "Erro ao cadastrar segmento", error);
      } finally {
        this.loadingClassificacao = false;
      }
    },
    HideModalFingerprintIP: function () {
      this.isListFingerprint = true;
      this.loadingFingerprint = false;
      this.filterText = "fingerprint";
      this.isListIP = false;
      this.ResetPaginationFingerprint();
      this.ResetPaginationIP();
      this.$bvModal.hide("mFingerprint");
    },
    ResetPaginationFingerprint: function () {
      this.paginationFingerprint = {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      };
    },
    ResetPaginationIP: function () {
      this.paginationIP = {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      };
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchant();
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ReturnToRootFilter() {
      this.filter = Object.assign({}, this.filterRoot);
      this.isMerchantRoot = true;
      this.idMerchantRoot = 0;
      this.filterRoot = {};
      this.ListMerchant();
    },
    CheckFiltersOnStore() {
      const filters = this.$store.getters.Filters.merchants;
      if (filters.filter != undefined) {
        this.filter = filters.filter;
        this.isMerchantRoot = filters.filter.IsMerchantRoot;
        this.idMerchantRoot = filters.idMerchantRoot;
        this.filterRoot = filters.filterRoot;
      }
    },
    SetFiltersOnStore() {
      if (this.firstLoad == false) {
        let filters = this.$store.getters.Filters;
        if (this.isMerchantRoot) {
          Object.assign(filters, {
            merchants: {
              filter: this.filter,
              idMerchantRoot: this.idMerchantRoot,
              filterRoot: {},
            },
          });
        } else {
          const filterRoot =
            JSON.stringify(filters.merchants.filterRoot) == "{}"
              ? filters.merchants.filter
              : filters.merchants.filterRoot;
          Object.assign(filters, {
            merchants: {
              filter: this.filter,
              idMerchantRoot: this.idMerchantRoot,
              filterRoot: filterRoot,
            },
          });
        }
        this.$store.commit("SET_FILTERS", filters);
      }
      this.firstLoad = false;
    },
    ListMerchant: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.CodeMerchantType)) this.countFilter++;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IsRemoved)) this.countFilter++;
      if (hasValue(this.filter.IsTest)) this.countFilter++;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExpiredCommission)) this.countFilter++;
      if (hasValue(this.filter.SourceDescription)) this.countFilter++;
      if (hasValue(this.filter.AddressFilter.StateFilter.Initials)) this.countFilter++;
      if (hasValue(this.filter.IsAcceptedContract) && this.filter.IsAcceptedContract != 2) this.countFilter++;
      if (hasValue(this.filter.CreatedDateInitial)) this.countFilter++;
      if (hasValue(this.filter.CreatedDateEnd)) this.countFilter++;

      if (hasValue(this.filter.CreatedDateInitial) && hasValue(this.filter.CreatedDateEnd)) {
        if (this.filter.CreatedDateInitial > this.filter.CreatedDateEnd) {
          this.$makeToast("A data Final deve ser maior que a data Inicial.",
            "danger",
            "Data incorreta.",);
          this.loadingList = false;
          return;
        }
      }

      this.loading = true;
      this.filter.IsMerchantRoot = this.isMerchantRoot;
      this.isRemoved = this.filter.IsRemoved;
      let params = this.GetParamsData();
      this.SetFiltersOnStore();
      this.$store
        .dispatch("ListMerchant", { params: params })
        .then((response) => {
          this.merchants = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os clientes", error);
        })
        .finally(() => (this.loading = false));
    },
    ListMerchantDocs: function (id) {
      this.$store
        .dispatch("ListMerchantDocs", { id: id })
        .then((response) => {
          this.merchantDocs = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os documentos", error);
        });
    },
    ListMerchantChecklist: function (id) {
      this.$store
        .dispatch("ListMerchantChecklist", { id: id })
        .then((response) => {
          this.merchantCheckLists = response.Checklists;
          this.merchantCheckListDates = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os checklists", error);
        });
    },
    ListMerchantCnae: function (id) {
      this.$store
        .dispatch("ListMerchantCnae", { id: id })
        .then((response) => {
          this.merchantCnaes = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os cnaes", error);
        });
    },
    LoadClassificacaoMerchant: function (id) {
      this.$store
        .dispatch("GetMerchantClassificacao", id)
        .then((response) => {
          this.merchantClassificacao = response || null;
        })
        .catch(() => {
          this.merchantClassificacao = null;
        });
    },
    ListMerchantPreviewHistory: function (id) {
      this.$store
        .dispatch("ListMerchantPreviewHistory", { id: id })
        .then((response) => {
          this.merchantsPreviewHistory = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar o histórico de pré-cadastro do cliente.", error);
        });
    },
    ListAlertaMerchant: function (id) {
      this.$store
        .dispatch("ListAlertaMerchantPorMerchant", id)
        .then((response) => {
          this.listaAlertasMerchant = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os alertas do merchant", error);
        })
        .finally(() => (this.loadingList = false));
    },
    OpenMerchantSubAccount: function (e, idMerchant) {
      e.preventDefault();
      this.idMerchantRoot = idMerchant;
      this.isMerchantRoot = false;
      this.filterRoot = Object.assign({}, this.filter);
      this.ResetFilter();
    },
    OpenMerchantSubAccountMarketPlace: function (e, id, idMerchantRoot) {
      e.preventDefault();
      this.idMerchant = id;
      this.idMerchantRoot = idMerchantRoot;
      this.modalPaymentMethod = true;
    },
    OpenMerchantHistory: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-history",
        params: { idMerchant: id },
      });
    },
    OpenMerchantTransaction: function (e, idMerchant) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-transaction",
        params: { idMerchant: idMerchant },
      });
    },
    OpenMerchantNotification(e, idMerchant) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-notification",
        params: { idMerchant: idMerchant },
      });
    },
    OpenPlan: function (e, idMerchant) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-plan",
        params: { idMerchant: idMerchant },
      });
    },
    OpenMerchantSubscription: function (e, idMerchant) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-subscription",
        params: { idMerchant: idMerchant },
      });
    },
    OpenTicketRegister: function (e, payload) {
      e.preventDefault();
      this.$root.$emit("OpenMTicketRegister", payload);
    },
    AfterCloseTicketRegister: function () {
      this.idMerchant = 0;
      this.idTicket = 0;
    },
    DownloadMerchantDoc: function (e, i) {
      e.preventDefault();
      this.loadingDownload = true;
      let merchantDoc = this.merchantDocs[i];
      window.open(merchantDoc.Url, "_self");
      this.loadingDownload = false;
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ReportDate: this.profitDate,
        "InitialDate": this.filter.CreatedDateInitial,
        "EndDate": this.filter.CreatedDateEnd,
        "Object.Identity": this.filter.Identity,
        "Object.IsRemoved": this.filter.IsRemoved,
        "Object.IsTest": this.filter.IsTest,
        "Object.IsMerchantRoot": this.filter.IsMerchantRoot,
        "Object.MerchantType.Code": this.filter.CodeMerchantType,
        "Object.Partner.Id": this.filter.IdPartner,
        "Object.IdMerchantRoot": this.idMerchantRoot,
        "Object.Id": this.filter.Id == "" ? null : this.filter.Id,
        "Object.Name": this.filter.Name,
        "Object.IsExpiredCommission": this.filter.IsExpiredCommission,
        "Object.Source": this.filter.SourceDescription,
        "Object.Address.State.Initials": this.filter.AddressFilter.StateFilter.Initials,
        "Object.IsAcceptedContractFilter": this.filter.IsAcceptedContract,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      this.filter.IsMerchantRoot = this.isMerchantRoot;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchant", { params: data })
        .then((response) => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenModalReportProfit: function (e, root) {
      e.preventDefault();
      this.isMerchantRootReport = root;
      this.profitDate = this.$options.filters.date(this.$options.filters.addMonth(new Date(), -1), "YYYY-MM-DD");
      this.$bvModal.show("mReportProfit");
    },
    GetReportProfit: function () {
      this.$makeToast(
        "O relatório está sendo processado e você receberá um e-mail assim que finalizado",
        "info",
        "Relatório de faturamento"
      );
      this.loadingReportProfit = true;
      this.filter.IsMerchantRoot = this.isMerchantRootReport;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ProfitReportMerchant", {
          params: { ...data },
        })
        .then((response) => {
          this.$bvModal.hide("mReportProfit");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReportProfit = false;
          }, 1200);
        });
    },
    OpenModalReportState: function (e) {
      e.preventDefault();
      this.profitDate = this.$options.filters.date(this.$options.filters.addMonth(new Date(), -1), "YYYY-MM-DD");
      this.$bvModal.show("mReportState");
    },
    GetReportState: function () {
      this.$makeToast(
        "O relatório está sendo processado e você receberá um e-mail assim que finalizado",
        "info",
        "Relatório de faturamento"
      );
      this.loadingReportProfit = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchantState", {
          params: { ...data },
        })
        .then((response) => {
          this.$bvModal.hide("mReportState");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReportProfit = false;
          }, 1200);
        });
    },
    OpenModalReportCity: function (e) {
      e.preventDefault();
      this.profitDate = this.$options.filters.date(this.$options.filters.addMonth(new Date(), -1), "YYYY-MM-DD");
      this.$bvModal.show("mReportCity");
    },
    GetReportCity: function () {
      this.$makeToast(
        "O relatório está sendo processado e você receberá um e-mail assim que finalizado",
        "info",
        "Relatório de faturamento"
      );
      this.loadingReportProfit = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchantCity", {
          params: { ...data },
        })
        .then((response) => {
          this.$bvModal.hide("mReportCity");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReportProfit = false;
          }, 1200);
        });
    },
    OpenMerchantContract: function (e, merchant, isMarketplace) {
      e.preventDefault();
      this.ResetActiveMerchantResponsible();
      this.isMarketplace = isMarketplace;
      this.validatedMerchantContract = false;
      this.validatedMerchantContractDPO = false;
      this.validatedMerchantContractCharge = false;
      this.infoMerchantContract = {
        IdMerchant: merchant.Id,
        ResponsibleDPO: {
          ResponsibleName: null,
          ResponsibleOccupation: null,
          ResponsiblePhone: null,
          ResponsibleEmail: null,
        },
        Partner: merchant.Partner,
        PartnerSDR: merchant.PartnerSDR,
        Responsibles: [],
        IdPlan: null,
        MerchantType: {
          Id: 3,
        }
        // CodeMerchantType: 3
      };
      this.$bvModal.show("mFormMerchantContract");
    },
    OpenMerchantNegotiation: function (e, id) {
      e.preventDefault();
      this.MerchantNegotiationsFront = [];
      this.MerchantNegotiationsBack = [];
      this.ResetActiveMerchantResponsible();
      // this.isMarketplace = isMarketplace;
      // this.validatedMerchantContract = false;
      // this.validatedMerchantContractDPO = false;
      this.infoMerchantNegotiation = this.DefaultInfoMerchantNegotiation(id);
      this.idMerchant = id;
      // this.ListNegotiation(id);
      this.$bvModal.show("mFormMerchantNegotiation");
    },

    DefaultInfoMerchantNegotiation(idMerchant = 0) {
      return {
        IdPaymentMethod: null,
        Amount: null,
        DateNegotiation: null,
        IdMerchant: idMerchant,
      };
    },

    SaveMerchantNegotiation: function () {
      if (this.pOpened == null && this.MerchantNegotiationsFront.length > 0) {
        const MerchantNegotiationLot = {
          Merchant: { Id: this.idMerchant },
          MerchantNegotiations: this.MerchantNegotiationsFront,
        };
        this.$store
          .dispatch("AddMerchantNegotiation", MerchantNegotiationLot)
          .then(() => {
            this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");

            // this.ListNegotiation(this.idMerchant);
            this.MerchantNegotiationsFront = [];

            //this.$bvModal.hide("mFormMerchantNegotiation");
          })
          .catch((error) => {
            this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
          })
          .finally(() => {
            this.loadingAddUpdate = false;
            this.isSeeing = false;
          });
      } else {
        this.$makeToast("Inclua uma nova negociação para poder salvar.", "danger", "Nada adicionado.");
      }

      // });
    },
    GetMerchantContractValidate: function () {



      this.validatedMerchantContractCharge = true;
      this.$refs.MerchantContractChargeForm.validate().then((isValid) => {
        if (isValid) {
          if (!this.isMarketplace) {
            this.ValidateContract();
          } else {
            this.validatedMerchantContractDPO = true;
            this.$refs.MerchantContractDPOForm.validate().then((isValid) => {
              if (isValid) this.ValidateContract();
            });
          }
        }
      });
    },
    ValidateContract() {
      //Limpa os Partners caso estejam excluídos para que não sejam incluídos na merchant.contract e sejam comissionados erroneamente
      if (this.infoMerchantContract.Partner != null && this.infoMerchantContract.Partner.IsExcluded) {
        this.infoMerchantContract.Partner = null;
      }

      if (this.infoMerchantContract.PartnerSDR != null && this.infoMerchantContract.PartnerSDR.IsExcluded) {
        this.infoMerchantContract.PartnerSDR = null;
      }


      if (this.infoMerchantContract.IdPlan < 1) {
        this.$makeMsgBox(
          `Você confirma a geração de contrato sem um plano de cobrança de mensalidade?`,
          "Confirmar",
          this.GetMerchantContract
        );
      } else if (this.infoMerchantContract.Partner == null || this.infoMerchantContract.Partner.Name == null || this.infoMerchantContract.Partner.Name == "") {
        this.$makeMsgBox(
          this.htmlToVNode("Você confirma a geração de contrato para Merchant sem parceiro cadastrado? <br>" +
            "<u> Para contratos de Merchant sem parceiro, não haverá comissão. </u>"),
          "Confirmar",
          this.GetMerchantContract
        );

      } else if (this.infoMerchantContract.Partner.PartnerType.Code == '2' ||
        (this.infoMerchantContract.Partner.PartnerType.Code == '1' &&
          this.infoMerchantContract.PartnerSDR != null && this.infoMerchantContract.PartnerSDR.Name != null && this.infoMerchantContract.PartnerSDR.Name != "")) {

        var merchantType = this.merchantTypes.find(x => x.Id == this.infoMerchantContract.MerchantType.Id);
        var plan = this.plans.find(x => x.IdPlan == this.infoMerchantContract.IdPlan);

        this.$makeMsgBox(
          this.htmlToVNode(
            "Você confirma a geração de contrato para conta do tipo <u>" + merchantType.Name + "</u>" +
            " com o plano de cobrança <u>" + plan.Name + "</u>" + "?"),
          "Confirmar",
          this.GetMerchantContract
        );
        // this.GetMerchantContract();
      } else if (this.infoMerchantContract.Partner.PartnerType.Code == '1' &&
        (this.infoMerchantContract.PartnerSDR == null || this.infoMerchantContract.PartnerSDR.Name == null || this.infoMerchantContract.PartnerSDR.Name == "")) {

        this.$makeMsgBox(
          this.htmlToVNode(
            "Você confirma a geração de contrato para Merchant sem um vínculo de SDR? <br>" +
            "<u> Para contratos de Merchant sem SDR, a comissão será 100% para o representante comercial. </u>"),
          "Confirmar",
          this.GetMerchantContract
        );
      } else {
        this.GetMerchantContract()
      }
    },
    GetMerchantContract: function () {
      this.loadingContract = true;
      this.$store
        .dispatch("GetMerchantContract", this.infoMerchantContract)
        .then((response) => {
          if (response.UrlContract != null && response.UrlContract != undefined && response.UrlContract != "") {
            this.$bvModal.hide("mFormMerchantContract");
            this.$makeToast("Aguarde a conclusão do download", "info", "Contrato gerado com sucesso");
            window.open(response.UrlContract, "_self");
            this.ListMerchant();
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o contrato", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingContract = false;
          }, 1200);
        });
    },
    OpenUpdatePartner: function (e, id) {
      e.preventDefault();
      this.loadingModalPartner = true;
      this.validatedUpdatePartner = false;
      this.$bvModal.show("mFormUpdatePartner");
      this.$store
        .dispatch("GetMerchant", { id: id })
        .then((response) => {
          this.infoMerchantPartner = response;
          this.infoMerchantSolicitation = {
            Merchant: {
              Id: this.infoMerchantPartner.Id,
            },
            Partner: {
              Id: 0,
            },
            PartnerSDR: {
              Id: 0,
            },
            Reason: null,
          };
        })
        .catch((error) => {
          this.loadingModalPartner = false;
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cliente", error);
        })
        .finally(() => (this.loadingModalPartner = false));
    },
    UpdatePartner: function () {
      this.validatedUpdatePartner = true;
      this.$refs.UpdatePartnerForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedUpdatePartner = false;
          if ((
            (!hasValue(this.infoMerchantPartner.Partner.Id) && !hasValue(this.infoMerchantSolicitation.Partner.Id)) ||
            this.infoMerchantPartner.Partner.Id == this.infoMerchantSolicitation.Partner.Id
          ) && (!hasValue(this.infoMerchantPartner.PartnerSDR.Id) && !hasValue(this.infoMerchantSolicitation.PartnerSDR.Id) ||
            this.infoMerchantPartner.PartnerSDR.Id == this.infoMerchantSolicitation.PartnerSDR.Id)) {
            this.$makeToast(
              `Não houve alteração de parceiro e SDR, verifique os valores informados.`,
              "danger",
              "Erro ao solicitar alteração de parceiro"
            );
            return;
          }

          this.loadingUpdatePartner = true;
          this.$store
            .dispatch("AddMerchantSolicitation", this.infoMerchantSolicitation)
            .then((response) => {
              this.$bvModal.hide("mFormUpdatePartner");
              this.ListMerchant();
              this.$makeToast(
                `A solicitação para alterar o parceiro do cliente ${this.infoMerchantPartner.Name} foi efetuada`,
                "success",
                `Solicitação efetuada`
              );
              this.ResetInfoMerchantPartner();
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao solicitar alteração de parceiro", error);
            })
            .finally(() => {
              this.loadingUpdatePartner = false;
              this.validatedUpdatePartner = false;
            });
        }
      });
    },
    ResetFilter: function () {
      this.filter = {
        Id: null,
        Name: null,
        Identity: null,
        CodeMerchantType: null,
        IdPartner: this.idPartner > 0 ? this.idPartner : null,
        IsRemoved: false,
        IsTest: false,
        IsMerchantRoot: true,
        IsExpiredCommission: null,
        SourceDescription: null,
        IsAcceptedContract: this.listPendingAcceptedContract ? 0 : 2,
        AddressFilter: {
          StateFilter: {
            Initials: null,
          },
        },
        CreatedDateInitial: null,
        CreatedDateEnd: null,
      };
      this.pymtMethod = null;
      this.ListMerchant();
    },
    ResetActiveMerchantResponsible: function () {
      this.activeMerchantResponsible = {
        ResponsibleName: null,
        ResponsibleIdentity: null,
        ResponsibleEmail: null,
        CodeMerchantType: null,
        IdPlan: null,
      };
    },
    OpenModalBlockMerchant(i) {
      this.validatedBloquearForm = false;
      this.ResetMerchantBloquear();
      this.merchantBloquear = this.merchants[i];
      this.$bvModal.show("mFormBloquearMerchant");

    },
    // ProcessUpdateBlockedMerchant(i, block) {
    //   this.merchantBloquear = this.merchants[i];

    //   this.$makeMsgBox(
    //     `Você tem certeza que deseja ${block ? "remover e bloquear" : "ativar e desbloquear"} ${this.merchantBloquear.Name} (${this.merchantBloquear.Identity}) ?`,
    //     "Confirmar ação",
    //     this.UpdateBlockedMerchant,
    //     block
    //   );
    // },
    UpdateBlockedMerchant: function (block) {
      let label = block ? "bloqueado" : "desbloqueado";
      let merchantBlocked = {
        IdMerchant: this.merchantBloquear.Id,
        IsBlocked: block,
        Motivo: this.merchantBloquear.Observacao
      };

      this.validatedBloquearForm = true;
      this.$refs.BloquearMerchantForm.validate().then((isValid) => {

        if (block == false || isValid == true) {

          this.loadingUpdateBlocked = true;
          this.$store
            .dispatch("UpdateBlockedMerchant", merchantBlocked)
            .then(() => {
              this.ListMerchant();
              this.$makeToast(`${this.merchantBloquear.Name} foi ${label}`, "success", `Cliente ${label}`);
              this.$bvModal.hide("mFormBloquearMerchant");

            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", `Falha ao ${block ? "bloquear" : "desbloquear"} ${this.merchantBloquear.Name}.`, error);
            }).finally(() => (this.loadingUpdateBlocked = false));
        }

      });
    },
    ResetMerchantBloquear: function () {
      this.merchantBloquear = {
        Id: 0,
        Name: null,
        Identity: null,
        Observacao: null,
        IsBlocked: false,
        IsRemoved: false,
      }
    },
    OpenModalRemoveMerchant(i) {
      this.validatedRemoverForm = false;
      this.ResetMerchantRemover();
      this.merchantRemover = this.merchants[i];
      this.$bvModal.show("mFormRemoverMerchant");

    },
    // ProcessUpdateRemovedMerchant(i, disable) {
    //   this.merchantRemover = this.merchants[i];

    //   this.$makeMsgBox(
    //     `Você tem certeza que deseja ${disable ? "remover" : "ativar"} ${merchantRemover.Name} (${this.merchantRemover.Identity}) ?`,
    //     "Confirmar ação",
    //     this.UpdateRemovedMerchant,
    //     disable
    //   );
    // },
    UpdateRemovedMerchant: function (disable) {
      let label = disable ? "removido" : "ativado";
      let merchantRemoved = {
        Id: this.merchantRemover.Id,
        IsRemoved: disable,
        Observacao: this.merchantRemover.Observacao
      };

      this.validatedRemoverForm = true;
      this.$refs.RemoverMerchantForm.validate().then((isValid) => {

        if (disable == false || isValid == true) {

          this.loadingUpdateRemoved = true;

          this.$store
            .dispatch("UpdateRemovedMerchant", merchantRemoved)
            .then(() => {
              this.$bvModal.hide("mFormRemoverMerchant");
              this.ListMerchant();
              this.$makeToast(`${this.merchantRemover.Name} foi ${label}`, "success", `Cliente ${label}`);
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", `Falha ao ${disable ? "remover" : "ativar"} ${this.merchantRemover.Name}.`, error);
            }).finally(() => (this.loadingUpdateRemoved = false));
        }
      });

    },
    ResetMerchantRemover: function () {
      this.merchantRemover = {
        Id: 0,
        Name: null,
        Identity: null,
        Observacao: null,
        IsBlocked: false,
        IsRemoved: false,
      }
    },
    ConfirmResendEmail: function (e) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja enviar um e-mail com instruções de definição de senha para ${this.infoMerchant.Name}?`,
        "Confirmar",
        this.ResendEmail
      );
    },
    ResendEmail: function () {
      this.loadingResendEmail = true;
      this.$store
        .dispatch("ResendEmail", this.infoMerchant)
        .then((response) => {
          this.$makeToast("E-mail reenviado com sucesso", "success", "Reenviar e-mail");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao reenviar o e-mail", error);
        })
        .finally(() => (this.loadingResendEmail = false));
    },
    ConfirmResendTechEmail: function (e) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja enviar um e-mail de definição de senha para ${this.infoMerchant.TechName}?`,
        "Confirmar",
        this.ResendTechEmail
      );
    },
    ResendTechEmail: function () {
      this.loadingResendTechEmail = true;
      this.$store
        .dispatch("ResendTechEmail", this.infoMerchant)
        .then((response) => {
          this.$makeToast("E-mail reenviado com sucesso", "success", "Reenviar e-mail");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao reenviar o e-mail", error);
        })
        .finally(() => (this.loadingResendTechEmail = false));
    },
    SearchByZipCode: function () {
      if (this.isSeeing == false) {
        let zipCodeNumber = this.infoMerchant.Address.ZipCode.replace(/\D+/gm, "");

        if (zipCodeNumber.length != 8) {
          this.$makeToast("O CEP digitado não é válido. " + zipCodeNumber, "danger", "CEP inválido");
          return;
        }

        this.$store
          .dispatch("ListCep", { zipCode: zipCodeNumber })
          .then((response) => {
            if (response.erro) {
              this.$makeToast("Verifique o número digitado e tente novamente.", "warning", "CEP não encontrado");
              return;
            }
            this.isSearchZipCode = true;

            this.infoMerchant.Address.ZipCode = response.cep;
            this.infoMerchant.Address.Street = response.logradouro;
            this.infoMerchant.Address.District = response.bairro;

            this.infoMerchant.Address.Country.Name = "BRASIL";
            this.infoMerchant.Address.State.Initials = response.uf;
            this.infoMerchant.Address.City.Name = response.localidade;
          })
          .catch((error) => {
            this.$makeToast("Não foi possível buscar o endereço.", "danger", "Busca de endereço");
          });
      }
    },
    OpenMerchant: function (e, i, view) {
      // e.preventDefault();
      this.selected_payment = null;
      this.mCurrentStep = 0;
      this.ResetInfoMerchant();
      this.validatedResponsibleStep = false;
      this.validatedCompanyStep = false;
      this.validatedTechStep = false;
      this.validatedChangeEmail = false;

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idMerchant = this.merchants[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar cliente";
        this.isEdit = true;
        this.GetMerchant(this.idMerchant);
        this.GetMerchantSplitTax(this.idMerchant);
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Novo cliente";
      } else {
        // View
        this.pOpened = i;
        this.idMerchant = this.merchants[i].Id;
        this.isSeeing = true;
        this.isEdit = this.idMerchant > 0 && this.isSeeing;
        this.modalTitle = "Detalhes do cliente";
        this.GetMerchant(this.idMerchant);
        this.GetMerchantSplitTax(this.idMerchant);
        // this.ListMerchantTickets(this.idMerchant);
        this.merchantCnaes = [];
        this.merchantClassificacao = null;
        this.ListMerchantCnae(this.idMerchant);
        this.LoadClassificacaoMerchant(this.idMerchant);
        this.ListMerchantPreviewHistory(this.idMerchant);
        this.GetMerchantLimits(this.idMerchant);
        this.ListAlertaMerchant(this.idMerchant);
      }
      this.$bvModal.show("mFormMerchant");
    },
    OpenMTaxModify: function (idxPymt, idxTax = 0) {
      let pymt = this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt];

      this.infoTax = JSON.parse(
        JSON.stringify({
          ...pymt.ListTax[idxTax],
          PaymentIsEnabled: pymt.IsEnabled,
        })
      );
      this.taxPaymentMethod = pymt.PaymentMethod.Code;
      this.infoTaxIndexes = {
        Payment: idxPymt,
        Tax: idxTax,
      };

      this.$bvModal.show("mTaxModify");
    },
    ResetInfoMerchant: function () {
      this.mCurrentStep = 0;
      this.idMerchant = 0;
      this.idTicket = 0;
      this.merchantDocs = [];
      this.merchantTickets = [];
      this.infoMerchant = {
        Name: null,
        Identity: null,
        IsTest: false,
        IsMEI: false,
        IsSendWelcomeEmail: true,
        IsChangeAdmUser: false,
        MerchantType: {
          Code: null,
        },
        BillingType: {
          Code: null,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
        TypeReceipt: {
          Id: 0,
        },
        AntifraudeCategoria: {
          Id: null
        },
        AdditionalInformation: {
          IsOperation: false,
          GrossBillingAmount: 0,
          IsApi: false,
          IsInterface: false,
          IsOtherSoftware: false,
          IsMarketplace: false,
        },
        Address: {
          Street: "",
          District: null,
          Number: "",
          ZipCode: "",
          Complement: "",
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
        Configuration: {
          MerchantPaymentMethod: [],
        },
        IsAuthorizedAPI: true,
        IsEnabled3DS: false,
        ProviderPrimary: {
          Id: 0,
          Code: null,
          Name: null,
        },
        MaquinaMensalidade: {
          Id: 0,
          ValorAluguel: 0,
          ValorTpvParaIsencao: 0,
          TpvCompartilhado: false,
          Ativo: false
        }
      };
    },

    ResetInfoMerchantBankData: function () {
      this.infoMerchant.BankData = {
        Bank: {
          Code: null,
          Name: null
        },
        BankAgency: null,
        BankAgencyDigit: null,
        BankAccount: null,
        BankAccountDigit: null,
        AccountType: {
          Name: null
        }
      };

      this.infoMerchant.MerchantPaymentDate = {
        PlanFrequence: {
          Id: null,
          Name: null
        }
      };
    },

    ResetInfoMerchantPartner: function () {
      this.infoMerchantPartner = {
        Id: null,
        Name: null,
        Identity: null,
        SourceDescription: null,
        CreatedDate: null,
        MerchantType: {
          Code: null,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
      };
      this.infoMerchantSolicitation = {
        Merchant: {
          Id: 0,
        },
        Partner: {
          Id: 0,
        },
        PartnerSDR: {
          Id: 0,
        },
        Reason: null,
      };
    },
    GetMerchant: function (id) {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetMerchant", { id: id })
        .then((response) => {
          this.infoMerchant = response;
          this.ListMerchantDocs(id);
          this.ListMerchantChecklist(id);
          delete this.infoMerchant.Address.City.CodeIBGE;
          delete this.infoMerchant.Address.City.Id;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cliente", error);
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    GetMerchantSplitTax: function (id) {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetMerchantSplitTax", { id: id })
        .then((response) => {
          this.infoMerchantSplitTax = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cliente", error);
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    AddMerchant: function () {
      this.loadingCreateUpdate = true;
      this.$store
        .dispatch("AddMerchant", this.infoMerchant)
        .then(() => {
          this.ListMerchant();
          this.$makeToast("Cliente cadastrado com sucesso", "success", "Cadastrado");
          this.$bvModal.hide("mFormMerchant");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao cadastrar cliente", error);
        })
        .finally(() => {
          this.loadingCreateUpdate = false;
        });
    },
    ModifyTax: function () {
      const idxPymt = this.infoTaxIndexes.Payment;
      const idxTax = this.infoTaxIndexes.Tax;

      let newTax = JSON.parse(JSON.stringify(this.infoTax));
      const pymtIsEnabled = newTax.PaymentIsEnabled;
      delete newTax.PaymentIsEnabled;

      this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt].ListTax[idxTax] = newTax;

      let lastAmount = newTax.Amount;

      if (this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt].ListTax.length > 1) {
        // Change the tax type for all taxes to avoid different tax types.
        this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt].ListTax.forEach((elm) => {
          elm.TaxType.Code = newTax.TaxType.Code;
          elm.Amount = lastAmount;
          lastAmount += 0.5;
        });
      }

      this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt].IsEnabled = pymtIsEnabled;

      this.tableKey += 1; // This will force-update the table.
      this.$bvModal.hide("mTaxModify");
    },
    BlockPaymentMethod: function (idxPymt) {
      let pymtMethod;

      if (this.isMerchantRoot) {
        pymtMethod = this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt];
      } else {
        pymtMethod = this.infoMerchantSplitTax[idxPymt];
      }

      if (!pymtMethod) {
        this.$makeToast(undefined, "danger", "Erro ao localizar o método de pagamento.");
        return;
      }

      const atual = this.isMerchantRoot
        ? pymtMethod.IsSecurityApproved
        : pymtMethod.PaymentMethod.IsSecurityApproved;

      const novoEstado = !atual;

      if (this.isMerchantRoot) {
        this.$set(
          this.infoMerchant.Configuration.MerchantPaymentMethod[idxPymt],
          "IsSecurityApproved",
          novoEstado
        );
      } else {
        this.$set(
          this.infoMerchantSplitTax[idxPymt].PaymentMethod,
          "IsSecurityApproved",
          novoEstado
        );

        const idMPM = pymtMethod.PaymentMethod.IdMerchantPaymentMethod;

        const mpm = this.infoMerchant.Configuration.MerchantPaymentMethod.find(
          (m) => m.Id === idMPM
        );

        if (mpm) {
          mpm.IsSecurityApproved = novoEstado;
        } else {
          this.$makeToast(
          "Ocorreu um erro ao atualizar o Método de Pagamento.",
          "danger",
          "Erro");
        }
      }

      this.tableKey += 1;
    },
    OpenModalMotivoAtualizacao() {
      this.merchantAtualizar = {
        Id: this.infoMerchant.Id,
        Name: this.infoMerchant.Name,
        Identity: this.infoMerchant.Identity,
        Observacao: "",
      };
      this.validatedAtualizarForm = false;
      this.$bvModal.show("mFormMotivoAtualizacao");
    },
    async ConfirmarAtualizacao() {
      this.validatedAtualizarForm = true;

      const valid = await this.$refs.AtualizarMerchantForm.validate();
      if (!valid) return;

      this.loadingUpdateBlocked = true;

      try {
        this.$bvModal.hide("mFormMotivoAtualizacao");

        await this.CreateOrUpdate(this.merchantAtualizar.Observacao);

      } catch (err) {
        console.error(err);
        this.$makeToast(
          "Ocorreu um erro ao atualizar o merchant.",
          "danger",
          "Erro"
        );
      } finally {
        this.loadingUpdateBlocked = false;
      }
    },

    CreateOrUpdate: function () {
      if (this.pOpened == null) {
        this.$makeMsgBox(
          "Você tem certeza que deseja cadastrar o merchant " + this.infoMerchant.Name + "?",
          "Confirmar alterações",
          this.AddMerchant()
        );
      } else {
        this.UpdateMerchant(this.merchantAtualizar.Observacao)
      }
    },
    UpdateMerchant: function (observacao) {
      this.loadingCreateUpdate = true;
      this.infoMerchant.Address.StateInitials = this.infoMerchant.Address.State.Initials;

      if (this.$getUserInternal()) this.infoMerchant.UserInternal = this.$getUserInternal();
      if (observacao) {
        this.infoMerchant.Observacao = observacao;
      }
      delete this.infoMerchant.BankData;
      this.$store
        .dispatch("UpdateMerchant", this.infoMerchant)
        .then(() => {
          this.$makeToast("O cliente foi atualizado com sucesso", "success", "Atualizado");
          this.ListMerchant();
          this.$bvModal.hide("mFormMerchant");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao atualizar cliente " + this.infoMerchant.Name + ".", error);
        })
        .finally(() => {
          this.loadingCreateUpdate = false;
        });
    },
    ChangeMerchantType: function (merchantTypeCode) {
      this.infoMerchant.MerchantType.Code = merchantTypeCode;
      delete this.infoMerchant.MerchantType.Name;
    },
    UpdateMerchantMethodsAndTaxes: function (merchantTypeCode) {
      // Set on MerchantPaymentMethods the pre-defined payment methods and taxes.
      this.infoMerchant.Configuration.MerchantPaymentMethod = [];

      let paymentMethods = [];
      let map = new Map();

      this.configurationTaxes.forEach(function (taxItem) {
        if (taxItem.MerchantType.Code == merchantTypeCode) {
          // Get just with the current merchant type.
          let tax = JSON.parse(JSON.stringify(taxItem));
          delete tax.Id;
          delete tax.MerchantType;
          delete tax.PaymentMethod;

          if (!map.has(taxItem.PaymentMethod.Code)) {
            // Not added so add the payment method.
            let pymtMethod = {
              PaymentMethod: taxItem.PaymentMethod,
              IsEnabled: true,
              ListTax: [tax],
            };
            paymentMethods.push(pymtMethod);
            map.set(taxItem.PaymentMethod.Code, true);
          } else {
            // Already added, append just the tax on the tax list. (e.g for credit card)
            const pymtIndex = paymentMethods.findIndex(function (elm) {
              return elm.PaymentMethod.Code == taxItem.PaymentMethod.Code;
            });
            paymentMethods[pymtIndex].ListTax.push(tax);
          }
        }
      });

      this.infoMerchant.Configuration.MerchantPaymentMethod = paymentMethods;
    },
    Update: function (key, value) {
      if (key != null) this.infoMerchant[key] = value;
    },
    UpdateValidated: function (key, value) {
      if (key != null) this.infoValidateMerchant[key] = value;
    },
    CheckValidityStep(step, nextStep) {
      if (step) {
        if (step == "TechStep") {
          this.$refs.TechStep.validate().then((isValid) => {

            const isEmpty = !this.infoMerchant.TechEmail && !this.infoMerchant.TechIdentity && !this.infoMerchant.TechName && !this.infoMerchant.TechPhone;

            if (!isValid && !isEmpty) {
              this.validatedTechStep = true;
            } else {
              if (nextStep == null) {
                this.NextStep();
              } else {
                this.mCurrentStep = nextStep;
              }
              this.validatedTechStep = false;
            }
          });
          return;
        }

        this.$refs[step].validate().then((isValid) => {
          if (isValid && nextStep == null) {
            this.NextStep();
          } else if (isValid) {
            if (step == "CompanyStep") {
              this.mCurrentStep = 1;
              this.validatedResponsibleStep = true;
              this.CheckValidityStep("ResponsibleStep", nextStep);
            } else if (step == "ResponsibleStep") {
              this.mCurrentStep = 2;
              this.CheckValidityStep("TechStep", nextStep);
            } else {
              this.mCurrentStep = nextStep;
            }
          }
        });
      }
    },
    HideModal: function () {
      this.$bvModal.hide("mFormMerchant");
    },
    ProcessNextStep: function (nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
      switch (this.mCurrentStep) {
        case 0: // Empresa
          this.validatedCompanyStep = true;
          this.CheckValidityStep("CompanyStep", nextStep);
          break;
        case 1: // Responsavel
          this.validatedResponsibleStep = true;
          this.CheckValidityStep("ResponsibleStep", nextStep);
          break;
        case 2: // Responsável Técnico.
          this.CheckValidityStep("TechStep", nextStep);
          break;
        default:
          if (nextStep != null) {
            this.mCurrentStep = nextStep;
          } else {
            this.NextStep();
          }
          break;
      }
    },
    FillSteps: function () {
      this.arraySteps = [];
      this.arraySteps.push(0); // Dados Merchant
      if(this.infoMerchant.MerchantType.Code != '1') {
        this.arraySteps.push(1); // Responsável
        this.arraySteps.push(2); // Contato Técnico
      }
      this.arraySteps.push(3); // Taxas
      this.arraySteps.push(4); // Informações

    
      if (this.HasMerchantDocs) {
        this.arraySteps.push(5); // Documentos
      }
      if (this.HasMerchantCheckList && this.isSeeing) {
        this.arraySteps.push(6); // Checklist
      }
      // 7 nao tem

      if (this.HasPerfilAtuacao) {
        this.arraySteps.push(8); // Perfil de Atuação
      }

      if (this.HasMerchantBankData && this.isSeeing) {
        this.arraySteps.push(9); // Banco
      }

      if (this.HasMerchantPreview && this.isSeeing) {
        this.arraySteps.push(10); // Histórico
      }
      if (this.isSeeing) {
        this.arraySteps.push(11); // Limites
        this.arraySteps.push(12); // Alertas
      }
      this.arraySteps.push(13); // Maquininhas

      if (!this.isSeeing) {
        this.arraySteps.push(14); // Confirmação
      }
    },
    NextStep: function () {
      this.FillSteps();
      var indexCurrentStep = this.arraySteps.findIndex(x => x == this.mCurrentStep);
      this.mCurrentStep = this.arraySteps[++indexCurrentStep];
    },
    BackStep: function () {
      this.FillSteps();
      var indexCurrentStep = this.arraySteps.findIndex(x => x == this.mCurrentStep);
      this.mCurrentStep = this.arraySteps[--indexCurrentStep];
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();

      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    AddPaymentMethod: function (e) {
      e.preventDefault();

      this.validatedTaxForm = true;
      this.$refs.TaxValidationForm.validate().then((isValid) => {
        if (!isValid) {
          return;
        } else {
          this.validatedTaxForm = false;

          const selectedPaymentCode = this.activeTaxConfig.PaymentMethod.Code;

          let pymtMethod = this.infoMerchant.Configuration.MerchantPaymentMethod.find(
            // Search for duplicates
            function (elm) {
              return elm.PaymentMethod.Code == selectedPaymentCode;
            }
          );

          if (pymtMethod != null) {
            this.$makeToast("Método de pagamento já foi adicionado!", "danger", "Erro");
            return;
          }
          if (this.activeTaxConfig.PaymentMethod.Code == null) {
            this.$makeToast("O código do método de pagamento é nulo!", "danger", "Um erro ocorreu");
            return;
          }

          let taxItem = JSON.parse(JSON.stringify(this.activeTaxConfig));
          delete taxItem.Id;
          delete taxItem.MerchantType;
          delete taxItem.PaymentMethod;
          delete taxItem.IsEnabled;

          if (selectedPaymentCode == "2") {
            // Add Credit Card payment method with the first tax.
            let indxCC = this.infoMerchant.Configuration.MerchantPaymentMethod.push({
              PaymentMethod: this.activeTaxConfig.PaymentMethod,
              IsEnabled: this.activeTaxConfig.IsEnabled,
              ListTax: [taxItem],
            });

            // Filter taxes for cc pymt method.
            let creditCardTaxes = this.currentTaxes.filter((elm) => {
              return elm.PaymentMethod.Code == "2" && elm.EndInstallment != 1;
            });

            let lastAmount = taxItem.Amount + 0.5;

            // Add all the taxes for Credit Card payment method.
            creditCardTaxes.forEach((TaxIter) => {
              let tax = JSON.parse(JSON.stringify(TaxIter));

              delete tax.Id;
              delete tax.MerchantType;
              delete tax.PaymentMethod;
              tax.Amount = lastAmount;

              this.infoMerchant.Configuration.MerchantPaymentMethod[indxCC - 1].ListTax.push(tax);

              lastAmount += 0.5;
            });
          } else {
            this.infoMerchant.Configuration.MerchantPaymentMethod.push({
              PaymentMethod: this.activeTaxConfig.PaymentMethod,
              IsEnabled: this.activeTaxConfig.IsEnabled,
              ListTax: [taxItem],
            });
          }

          // CLEAR INFO AFTER PAYMENT METHOD INCLUDED.
          this.selected_payment = null;
          this.activeTaxConfig = {
            PaymentMethod: {
              Code: null,
              Name: null,
            },
            TaxType: {
              Code: 1,
            },
            InitialInstallment: null,
            EndInstallment: null,
            IsEnabled: false,
            Amount: null,
          };
        }
      });
    },
    RemovePaymentMethod: function (pymtMethodCode) {
      let pymtMethodIndex = this.infoMerchant.Configuration.MerchantPaymentMethod.findIndex(function (elm) {
        return elm.PaymentMethod.Code == pymtMethodCode;
      });

      if (pymtMethodIndex != -1) {
        this.infoMerchant.Configuration.MerchantPaymentMethod.splice(pymtMethodIndex, 1);
      }
    },
    AddMerchantResponsible: function (e) {
      e.preventDefault();
      this.validatedMerchantContract = true;
      this.$refs.MerchantContractForm.validate().then((isValid) => {
        if (!isValid) {
          return;
        } else {
          this.validatedMerchantContract = false;

          if (
            this.infoMerchantContract.Responsibles != null &&
            this.infoMerchantContract.Responsibles != undefined &&
            this.infoMerchantContract.Responsibles.length > 0
          ) {
            const selectedIdentity = this.activeMerchantResponsible.ResponsibleIdentity;

            let identity = this.infoMerchantContract.Responsibles.find(
              // Search for duplicates
              function (elm) {
                return elm.ResponsibleIdentity == selectedIdentity;
              }
            );

            if (identity != null) {
              this.$makeToast("Este responsável já foi adicionado", "danger", "Incluir Responsável");
              return;
            }
          }

          this.infoMerchantContract.Responsibles.push({
            Id: this.infoMerchantContract.Responsibles.length + 1,
            ResponsibleName: this.activeMerchantResponsible.ResponsibleName,
            ResponsibleIdentity: this.activeMerchantResponsible.ResponsibleIdentity,
            ResponsibleEmail: this.activeMerchantResponsible.ResponsibleEmail,
          });

          this.ResetActiveMerchantResponsible();
        }
      });
    },
    RemoveMerchantResponsible: function (index) {
      if (index != -1) {
        this.infoMerchantContract.Responsibles.splice(index, 1);
      }
    },

    AddMerchantNegotiation: function (infoMerchantNegotiation) {
      if (
        infoMerchantNegotiation &&
        infoMerchantNegotiation.IdPaymentMethod &&
        infoMerchantNegotiation.Amount &&
        infoMerchantNegotiation.DateNegotiation
      ) {
        const paymentMethod = this.paymentMethods.find((i) => i.Id == infoMerchantNegotiation.IdPaymentMethod);
        infoMerchantNegotiation.PaymentMethod = paymentMethod;
        infoMerchantNegotiation.Id = 0;

        this.MerchantNegotiationsFront.push({ ...infoMerchantNegotiation });
        setTimeout(() => {
          this.infoMerchantNegotiation = this.DefaultInfoMerchantNegotiation(infoMerchantNegotiation.IdMerchant);
        }, 10);
      } else {
        this.$makeToast(`Preencha todos os campos para incluir.`, "danger", `Preencha os campos`);
      }
    },

    ListConfigurationTax: function () {
      this.$store
        .dispatch("ListConfigurationTax", {})
        .then((response) => {
          this.configurationTaxes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de taxas", error);
        });
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          if (response.Objects && response.Objects.length > 0) {
            this.partners = response.Objects.filter(x => x.PartnerType.Code == "1" || x.PartnerType.Code == "2");
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de parceiros", error);
        });
    },
    ListSDRs: function () {
      this.$store
        .dispatch("ListSDRs")
        .then((response) => {
          this.sdrs = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de SDRs", error);
        });
    },
    ListMerchantType: function () {
      this.$store
        .dispatch("ListMerchantType")
        .then((response) => {
          this.merchantTypes = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de conta", error);
        });
    },
    ListGateways: function () {
      this.$store
        .dispatch("ListGateway")
        .then((response) => {
          this.gateways = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de bancos", error);
        });
    },
    ListBillingType: function () {
      this.$store
        .dispatch("ListBillingType")
        .then((response) => {
          this.billingTypes = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de faturamento", error);
        });
    },
    ListTypeReceipt: function () {
      this.$store
        .dispatch("ListTypeReceipt", { params: {} })
        .then((response) => {
          this.typesReceipt = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de recebimento", error);
        });
    },
    ListPaymentMethods: function () {
      this.$store.dispatch("ListPaymentMethodIsEnabled").then((response) => {
        this.paymentMethods = response.Objects;
      });
    },
    ListCountry: function () {
      this.$store
        .dispatch("ListCountry")
        .then((response) => {
          this.countries = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de países", error);
        });
    },
    ListState: function (nameCountry) {
      if (nameCountry != null) {
        let CountryItem = this.countries.find((elem) => {
          return elem.Name.toUpperCase() == nameCountry;
        });

        if (CountryItem != null && CountryItem.Id != null) {
          this.$store
            .dispatch("ListState", { idCountry: CountryItem.Id })
            .then((response) => {
              this.states = response;
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao obter lista de estados", error);
            });
        }
      }
    },
    previousPage: function () {
      const qs = require("qs");
      const prev = qs.parse(this.previousPageinfo);
      const component = prev.component;
      delete prev.component;

      this.$router.push({
        name: component,
        query: {
          previous: qs.stringify(prev),
        },
      });
    },
    GetGenericName: function (ArrayName, ObjCode) {
      if (!hasValue(ObjCode)) return "";
      let elm = this[ArrayName].find((e) => {
        return e.Code === ObjCode;
      });
      if (elm === undefined) return "";
      return elm.Name || "";
    },
    ListStateFilter: function () {
      this.$store.dispatch("ListState", { idCountry: 24 }).then((response) => {
        this.statesFilter = response;
      });
    },
    // OnCloseTicketModal: function (data) {
    // let hasChanges = data.HasChanges;
    // if (hasChanges) this.ListMerchantTickets(this.infoMerchant.Id);
    // },
    GetBlockedClass: function (isBlocked) {
      return isBlocked ? "fas fa-ban fa-red" : "fas fa-minus";
    },
    OpenModalFingerprintIP(e, id) {
      e.preventDefault();
      this.idMerchant = id;
      this.$bvModal.show("mFingerprint");
      this.ListFingerprint(this.idMerchant);
    },
    ClickFingerprint() {
      this.filterText = "fingerprint";
    },
    ClickIP() {
      this.filterText = "ip";
    },
    ClickFingerprint() {
      this.filterText = "fingerprint";
      if (this.paginationFingerprint.PageNumber !== 1) this.paginationFingerprint.PageNumber = 1;
      else this.ListFingerprint(this.idMerchant);
    },
    ClickIP() {
      this.filterText = "ip";
      if (this.paginationIP.PageNumber !== 1) this.paginationIP.PageNumber = 1;
      else this.ListIP(this.idMerchant);
    },
    ListFingerprint: function (id) {
      this.loadingFingerprint = true;
      this.isListFingerprint = true;
      let data = {
        ...this.paginationFingerprint,
        "Object.IdMerchant": id,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListFingerprint", { params: data })
        .then((response) => {
          this.fingerprints = response.Objects;
          this.paginationFingerprint.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os fingerprints", error);
        })
        .finally(() => {
          this.loadingFingerprint = false;
        });
    },
    ListIP: function (id) {
      this.loadingIP = true;
      this.isListIP = true;
      let data = {
        ...this.paginationIP,
        "Object.IdMerchant": id,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListIP", { params: data })
        .then((response) => {
          this.ips = response.Objects;
          this.paginationIP.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os IPs", error);
        })
        .finally(() => {
          this.loadingIP = false;
        });
    },
    OpenMerchantDocument: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-document",
        params: { idMerchant: id },
      });
    },
    OpenMerchantNotes: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-notes",
        params: { idMerchant: id },
      });
    },
    OpenMerchantContact: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-contact",
        params: { idMerchant: id },
      });
    },
    OpenMerchantUser: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-user",
        params: { idMerchant: id },
      });
    },
    OpenMerchantTrainings: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-trainings",
        params: { idMerchant: id },
      });
    },
    OpenChangeEmail: function (e, id) {
      e.preventDefault();
      this.loadingChangeEmail = true;
      this.GetMerchant(id);
      this.validatedChangeEmail = false;
      this.infoMerchantChangeEmail = {
        Id: id,
        Email: null,
        IsChangeAdmUser: false,
        ResponsibleIdentity: null,
      };
      this.$bvModal.show("mChangeEmail");
      this.loadingChangeEmail = false;
    },
    ValidateUpdateEmail: function () {
      this.validatedChangeEmail = true;
      this.$refs.ChangeEmailForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedChangeEmail = false;
          this.infoMerchantChangeEmail.ResponsibleIdentity = this.infoMerchant.ResponsibleIdentity;
          this.$store
            .dispatch("ValidateChangeEmail", this.infoMerchantChangeEmail)
            .then((response) => {
              if (response.HasErrorValidate) {
                this.ConfirmHasErrorValidateEmail(response);
              } else {
                this.UpdateChangeEmail();
              }
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao validar o cliente", error);
            })
            .finally(() => {
              this.loadingChangeEmail = false;
            });
        }
      });
    },
    ConfirmHasErrorValidateEmail: function (response) {
      this.$makeMsgBox(
        this.htmlToVNode(response.MessageValidate + "Você tem certeza que deseja continuar?"),
        "Confirmar",
        this.UpdateChangeEmail,
        response
      );
    },
    UpdateChangeEmail: function () {
      this.validatedChangeEmail = true;
      this.$refs.ChangeEmailForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedChangeEmail = false;
          this.infoMerchantChangeEmail.ResponsibleIdentity = this.infoMerchant.ResponsibleIdentity;
          this.infoMerchantChangeEmail.ResponsibleName = this.infoMerchant.ResponsibleName;
          this.$store
            .dispatch("UpdateChangeEmail", this.infoMerchantChangeEmail)
            .then(() => {
              this.ListMerchant();
              this.$makeToast(`E-mail atualizado com sucesso.`, "success", `Cliente atualizado com sucesso.`);
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", `Falha ao atualizar o E-mail.`, error);
            })
            .finally(() => {
              this.$bvModal.hide("mChangeEmail");
              this.loadingChangeEmail = false;
              this.validatedChangeEmail = false;
            });
        }
      });
    },
    OpenValidateMerchant: function (e) {
      e.preventDefault();
      this.loadingValidateMerchant = true;
      (this.infoValidateMerchant = {
        MerchantType: {
          Code: 2,
        },
        Email: null,
        ResponsibleIdentity: null,
        Identity: null,
        IsTest: false,
      }),
        (this.validatedMerchant = false);
      this.$bvModal.show("mValidateMerchant");
      this.loadingValidateMerchant = false;
    },
    htmlToVNode: function (html) {
      return [
        this.$createElement("div", {
          domProps: { innerHTML: this.$options.filters.breakline(html) },
        }),
      ];
    },
    ConfirmHasErrorValidate: function (response) {
      this.$makeMsgBox(
        this.htmlToVNode(response.MessageValidate + "Você tem certeza que deseja continuar?"),
        "Confirmar",
        this.SetMerchant,
        response
      );
    },
    SetMerchant: function (response) {
      this.OpenMerchant();
      this.MerchantTypeCode = response.MerchantType.Code;
      this.infoMerchant.Name = response.Name;
      this.infoMerchant.IsMEI = response.IsMEI;
      this.infoMerchant.Identity = response.Identity;
      this.infoMerchant.ResponsibleName = response.ResponsibleName;
      this.infoMerchant.ResponsibleIdentity = response.ResponsibleIdentity;
      this.infoMerchant.Email = response.Email;
      this.infoMerchant.IsTest = response.IsTest;
      this.isValidated = true;
      this.$bvModal.hide("mValidateMerchant");
    },
    ValidateMerchant: function () {
      this.validatedMerchant = true;
      this.$refs.ValidateMerchantForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedMerchant = false;
          this.loadingValidateMerchant = true;
          this.$store
            .dispatch("ValidateMerchant", this.infoValidateMerchant)
            .then((response) => {
              if (response.HasErrorValidate) {
                this.ConfirmHasErrorValidate(response);
              } else {
                this.SetMerchant(response);
              }
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao validar o cliente", error);
            })
            .finally(() => {
              this.loadingValidateMerchant = false;
            });
        }
      });
    },
    OpenCheckingAccount: function (e, idMerchant) {
      e.preventDefault();
      this.$router.push({
        name: "merchant-checking-account",
        params: { idMerchant: idMerchant },
      });
    },
    ClearSession: function (e, idMerchant) {
      this.$store
        .dispatch("ClearSessionMerchant", idMerchant)
        .then((response) => {
          this.$makeToast("Operação realizada com sucesso.", "success", "Limpar sessão");
        })
        .catch((error) => {
          this.$makeToast("Erro ao realizar a operação.", "danger", "Erro", error);
        })
        .finally(() => { });
    },
    LiberarDadosIntegracao: function (e, idMerchant) {
      this.$store
        .dispatch("LiberarDadosIntegracao", idMerchant)
        .then((response) => {
          this.$makeToast("Operação realizada com sucesso.", "success", "Liberar Dados de Integração");
        })
        .catch((error) => {
          this.$makeToast("Erro ao realizar a operação.", "danger", "Erro", error);
        })
        .finally(() => { });
    }
    ,
    OpenModalMerchantLimits: function (e, id) {
      e.preventDefault();
      this.ResetMerchantLimits();
      this.GetMerchantLimits(id);
      this.$bvModal.show("mFormMerchantLimits");
    },
    HideModalMerchantLimits: function () {
      this.$bvModal.hide("mFormMerchantLimits");
    },
    ResetMerchantLimits: function () {
      this.infoMerchantLimits = {
        AntecipacaoPercentualMaximo: 0,
        DisputaPercentualMaximo: 0
      };
    },
    GetMerchantLimits: function (id) {
      this.loadingMerchantLimits = true;
      this.$store
        .dispatch("GetMerchantLimits", { id: id })
        .then((response) => {
          this.infoMerchantLimits = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter os dados de limite do cliente", error);
        })
        .finally(() => {
          this.loadingMerchantLimits = false;
        });
    },
    UpdateMerchantLimits: function () {
      this.validatedMerchantLimits = true;
      this.loadingCreateUpdate = true;

      this.$refs.MerchantLimitsForm.validate().then((isValid) => {
        if (isValid) {
          this.$store
            .dispatch("UpdateMerchantLimits", this.infoMerchantLimits)
            .then(() => {
              this.$makeToast("O limite do cliente foi atualizado com sucesso", "success", "Atualizado");
              this.$bvModal.hide("mFormMerchantLimits");
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao atualizar o limite do cliente.", error);
            })
            .finally(() => {
              this.loadingCreateUpdate = false;
            });
        } else this.loadingCreateUpdate = false;
      });
    },
    async OpenModalFrequenciaRepasse(e, id) {
      e.preventDefault();
      this.loadingEditarFrequenciaRepasse = true;
      this.$bvModal.show("mEditarFrequenciaRepasse");

      try {
        this.GetMerchant(id);
      }
      finally {
        this.loadingEditarFrequenciaRepasse = false;
      }
    },
    EditarFrequenciaRepasse() {
      this.validatedFrequenciaRepasse = true;
      this.loadingEditarFrequenciaRepasse = true;

      this.$refs.EditarFrequenciaRepasseForm.validate().then(isValid => {
        if (!isValid) {
          this.loadingEditarFrequenciaRepasse = false;
          return;
        }
        const selectedPlanId = this.infoMerchant.MerchantPaymentDate.PlanFrequence.Id;
        const selectedPlanName = this.infoMerchant.MerchantPaymentDate.PlanFrequence.Name;
        const estadoAnterior= this.estadoAnteriorFrequenciaRepasse;
        const estadoAtual = {
          planFrequenceId: selectedPlanId,
          paymentDay:
            selectedPlanId !== 7
              ? this.infoMerchant.MerchantPaymentDate.PaymentDay
              : null
        };

        const payload = {
          id: this.infoMerchant.MerchantPaymentDate.Id,
          name: selectedPlanName,
          paymentDay:
            selectedPlanId !== 7
              ? this.infoMerchant.MerchantPaymentDate.PaymentDay
              : null,

          merchant: {
            id: this.infoMerchant.Id
          },

          planFrequence: {
            id: selectedPlanId,
            code: selectedPlanId.toString(),
            name: this.infoMerchant.MerchantPaymentDate.PlanFrequence.Name || null
          },
          log: {
            entity: "MerchantPaymentDate",
            entityId: this.infoMerchant.MerchantPaymentDate.Id,

            before: estadoAnterior,
            after: estadoAtual
          }
        };

        this.$store
          .dispatch("EditarFrequenciaRepasse", payload)
          .then(() => {
            this.$makeToast(
              "A Frequência de Repasse foi atualizada com sucesso",
              "success",
              "Atualizado"
            );
            this.$bvModal.hide("mEditarFrequenciaRepasse");
          })
          .catch(error => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao editar a frequência de repasse",
              error
            );
          })
          .finally(() => {
            this.loadingEditarFrequenciaRepasse = false;
          });
      });
    },
    // ListNegotiation: function (id) {
    //   this.loadingNegotiation = true;
    //   this.$store
    //     .dispatch("ListNegotiation", { "Object.Merchant.Id": id })
    //     .then((response) => {
    //       this.MerchantNegotiationsBack = response.Objects;
    //     })
    //     .catch((error) => {
    //       this.$makeToast(undefined, "danger", "Erro ao Listar as Negociações", error);
    //     })
    //     .finally(() => {
    //       $("#dropTableOptions").dropdown("hide");
    //       this.loadingNegotiation = false;
    //     });
    // },
    ConfirmDeleteMerchantNegotiation(Negotiation, index) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover o item " + Negotiation.PaymentMethod.Name + "?",
        "Confirmar",
        this.RemoveMerchantNegotiation,
        { index, Negotiation }
      );
    },

    RemoveMerchantNegotiation(obj) {
      if (obj.Negotiation.Id == 0) {
        this.MerchantNegotiationsFront.splice(obj.index - this.MerchantNegotiationsBack.length, 1);
      } else {
        this.$store
          .dispatch("DeleteMerchantNegotiation", { id: obj.Negotiation.Id })
          .then(() => {
            this.$makeToast("O Item foi removido com sucesso.", "success", "Removido!");
            this.ListNegotiation(this.idMerchant);
            // this.$bvModal.hide("mFormMerchantNegotiation");
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao remover módulo.", error);
          });
      }
    },

    onChangePartner: function (value) {
      const result = this.partners.filter(p => p.Id == value)[0];

      if (result && result.PartnerType.Code == "1") {
        this.isAllowChooseSDR = true;
      } else {
        this.isAllowChooseSDR = false;
      }
    },

    changePartnerSolicitation: function (value) {
      const result = this.partners.filter(p => p.Id == value)[0];

      if (result && result.PartnerType.Code == "1") {
        this.isAllowChooseSDR = true;
      } else {
        this.isAllowChooseSDR = false;
        this.infoMerchantSolicitation.PartnerSDR.Id = 0;
      }
    },

    changeContractMerchantType: function (value) {
      if (value == 3) {
        this.isShowPlans = true;
      } else {
        this.isShowPlans = false;
        this.infoMerchantContract.IdPlan = null;
      }
    },

    listPlans: function () {
      this.$store
        .dispatch("GetMerchantPlans")
        .then((response) => {
          this.plans = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao buscar os planos cadastrados.", error);
        });
    },
  },
};
</script>

<style scoped>
.active-item {
  color: #fff !important;
  border-color: #00304d;
  background-color: #00304d;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.nav-tabs .active-item .nav-link {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}

.active-item a:-webkit-any-link {
  color: unset;
}

.td-with-subs {
  display: block;
}

.td-with-subs>span {
  font-size: 10pt;
  opacity: 0.75;
}

.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}

.tr-hidden {
  border-top: hidden;
}

.fa-red {
  color: #ff0000;
}

.ckb {
  margin-top: 35px;
}

.font-ckb {
  font-size: 12.3px;
}

.nav-steps .breadcrumb-item:before {
  content: none;
}

.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}

/* #textbox {display:flex; flex-flow:row wrap;} */
#input-optional {
  display: flex;
  justify-content: space-between;
}

.optional {
  color: #999;
  font-size: 86%;
}

.red {
  color: red
}
</style>



// WEBPACK FOOTER //
// src/components/pages/merchants.vue